import React from 'react'
import ReactDOM from 'react-dom'
import { configureStore, createSlice } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import Dashboard from '../layouts/v2/Dashboard'
import AllDashboard from '../layouts/v2/AllDashboard'
import AdminDashboard from '../layouts/v2/AdminDashboard'
import DashboardTables from '../layouts/DashboardTables'
import EditBusinessGroup from '../layouts/EditBusinessGroup'
import Notifications from '../v2/NotificationsV2'
import Timezone from '../Timezone'
import DynamicTitle from '../DynamicTitle'
import DynamicTitleV2 from '../v2/DynamicTitleV2'
import OnlineUsers from '../v2/OnlineUsersV2'
import ChatSettingsPrecanned from '../v2/ChatSettingsPrecanned'
import ChatSettingsAutoresponse from '../v2/ChatSettingsAutoresponse'
import FeedbackSettingsTagsV2 from '../v2/FeedbackSettingsTags'
import FeedbackSettingsForwards from '../v2/FeedbackSettingsForwards'
import WebsocketConnector from '../layouts/WebsocketConnector'
import SelectedFeedback from '../layouts/v2/SelectedFeedback'
import FeedbackerDetail from '../layouts/v2/FeedbackerDetail'
import Detail from '../layouts/Detail'
import Archive from '../layouts/v2/Archive'
import History from '../v2/HistoryV2'
import Messenger from '../layouts/Messenger'
import EmailRecipients from '../page/company-profile/v2/EmailRecipients'
import PhoneRecipients from '../page/company-profile/v2/PhoneRecipients'
import KeywordEmailRecipients from '../page/alert-keywords/v2/KeywordEmailRecipients'
import KeywordPhoneRecipients from '../page/alert-keywords/v2/KeywordPhoneRecipients'
import Modal from '../Modal'
import PasswordInput from '../PasswordInput'
import DemoCompaniesTable from '../DemoCompaniesTable'
import ReviewTrackers from '../ReviewTrackers'
import AISummary from '../AISummary'
import ManageVins from '../ManageVins'
import EditVin from '../EditVin'
import AddVin from '../AddVin'
import DGBSettings from '../DGBSettings'
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js'
import { chatDown, selectedFirst } from '../jquery/scrollcontrol'
import * as uuid from 'uuid'
import { parseInt } from 'lodash'
import Paginator from '../Classes/Paginator'
import moment from 'moment-timezone'
import io from '../../../../../public/js/manage/socket.io'

window.instance_uuid = uuid.v4();
export function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

var date = new Date();
var start_date = window.localStorage.getItem("prev_date") ?? `${date.toLocaleString("default", { year: "numeric" })}-${date.toLocaleString("default", { month: "2-digit" })}-${date.toLocaleString("default", { day: "2-digit" })}`;
var end_date = window.localStorage.getItem("next_date") ?? `${date.toLocaleString("default", { year: "numeric" })}-${date.toLocaleString("default", { month: "2-digit" })}-${date.toLocaleString("default", { day: "2-digit" })}`;

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  createCookie(name, "", -1);
}

createCookie("latest_browser_window", window.instance_uuid ?? "");

const pageSlice = createSlice({
  name: "page",
  initialState: {
    api_url: window.api_url ? "https://" + api_url : "https://api.realtimefeedback.com",
    title: window.title,
    more_title: window.more_title ?? null,
    initial_feedbacks: window.initial_feedbacks,
    user_departments: window.user_departments,
    feedback_tags: window.feedback_tags,
    tellmyco_id: window.tellmyco_id,
    businesses: window.businesses,
    business: window.business,
    businessGroup: window.businessGroup,
    businessHasAutoPilot: window.businessHasAutoPilot,
    businessHasWebWidget: window.businessHasWebWidget,
    feedback_count: window.feedback_count,
    paginate_count: window.paginate_count,
    stats_table: window.stats_table,
    totals: window.totals,
    is_super_user: window.is_super_user,
    selected_feedback: window.selected_feedback,
    feedback_detail: window.feedback_detail,
    red_alerts: window.red_alerts ?? null,
    red_alerts_list: window.red_alerts_list ?? null,
    online_users: window.online_users ?? [],
    user_table: window.user_table ?? null,
    selected_feedback_modal: null,
    alert: { alert_class: "none", alert_message: "none", alert: false },
    lastest_time: null,
    responseSuggestion: null,
    errorResponseSuggestion: null,
    modal: {
      modal_id: "id",
      modal_title: "title",
      modal_body: "body",
      button_1_class: "danger",
      button_1_id: "id",
      button_1_text: "button 1 text",
      button_2_class: "primary",
      button_2_id: "id",
      button_2_text: "button 2 text"
    },
    tag_state: { selectedValue: "" },
    isDashboard: document.getElementById('Dashboard') !== null ||
        document.getElementById('AdminDashboard') !== null ||
        document.getElementById('AllDashboard') !== null,
    isMobileVersion: isMobile(),
    current_forwards: [],
    current_email_forwards: [],
    all_forwards: [],
    current_user: window.current_user,
    current_page: window.current_page ?? 1,
    departments: (window.implode_departments ? window.implode_departments : null),
    department_ids: (window.backend_department_ids ? window.backend_department_ids : null),
    timeframe: window.localStorage.getItem('timeframe') ?? window.timeframe,
    timeframe_next: window.timeframe_next ?? end_date,
    timeframe_prev: window.timeframe_prev ?? start_date,
    max_Date: `${date.toLocaleString("default", { year: "numeric" })}-${date.toLocaleString("default", { month: "2-digit" })}-${date.toLocaleString("default", { day: "2-digit" })}`,
    other_filter: window.other_filter ?? null,
    status: window.status ?? null,
    hide_initial_feedbacks: window.hide_initial_feedbacks ?? null,
    loading: false,
    chatAnyway: false,
    loading_location: null,
    loading_data: null,
    feedbackPrompt: null,
    typing_timer: 0,
    search_typing_timer: 1,
    typing_name: null,
    typing_user_id: null,
    typing_is_business: null,
    next_cursor: window.next_cursor,
    prev_cursor: window.prev_cursor,
    query: window.prev_search_query ?? (window.localStorage.getItem('feedback_search') ?? ''),
    notification_permission: window.notification_permission,
    is_impersonating: window.is_impersonating ?? false,
    table_data: window.table_data ?? null,
    archive: window.is_archived ?? false,
    business_table_data: window.businesses_table_data ?? null,
    oldest_pending: window.oldest_pending ?? null,
    users_table_data: window.users_table_data ?? null,
    group: window.group,
    authenticatedUserPhone: window.authenticatedUserPhone,
    chatAttachments: window.chatAttachments,
    custom_qr_code: window.custom_qr_code,
    potential_recipients: window.potential_recipients
      ? window.potential_recipients.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    email_recipients: window.email_recipients
      ? window.email_recipients.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    phone_recipients: window.phone_recipients
      ? window.phone_recipients.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    precanned: window.precanned
      ? window.precanned.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    autoresponseKeywords: window.autoresponseKeywords
      ? window.autoresponseKeywords.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    business_tags: window.business && window.business.tags
      ? window.business.tags.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    business_forwards: window.business && window.business_forwards
      ? window.business_forwards.map(item => {
        item.uuid = uuid.v4();
        return item;
      })
      : null,
    region: (window.region ?? null),
    region_type: (window.region_type ?? null),
    checked_feedbacks: [],
    issueStories: window.issueStories,
    successStories: window.successStories,
    existingRecipients: window.existingRecipients,
    availablePeriods: window.availablePeriods,
    contacts: window.contacts,
    employees: window.employees,
    reportStartDate: window.reportStartDate,
    reportEndDate: window.reportEndDate,
    totalIssuesMentions: window.totalIssuesMentions,
    totalIssuesReviewMentions: window.totalIssuesReviewMentions,
    totalSuccessStoriesMentions: window.totalSuccessStoriesMentions,
    totalSuccessReviewStoriesMentions: window.totalSuccessReviewStoriesMentions,
    reportStartDateFormatted: window.reportStartDateFormatted,
    reportEndDateFormatted: window.reportEndDateFormatted,
      aiSummaryTotalFeedbacks: window.totalFeedbacks,
      aiSummaryTotalReviews: window.totalReviews,
    isManager: window.isManager,
    current_vin: window.current_vin,
    jwt: window.jwt,
    dgbApiUrl: window.dgbApiUrl,
    qrCodeEditUrl: window.qrCodeEditUrl,
    qrCodeAddUrl: window.qrCodeAddUrl,
    qrCodeUrl: window.qrCodeUrl,
    hasQrCodeForDgb: window.hasQrCodeForDgb,
    business_sorting: window.localStorage.getItem("business_sorting") ?? 'businessname asc',
    openStatusUrl: window.openStatusUrl,
    app_locale: window.app_locale,
    realTimeReviewsLabel: window.realTimeReviewsLabel
  },
  reducers: {
    setSelectedFeedback: function (state, action) {
      state.selected_feedback = action.payload;
      state.alert.alert = false;
      jQuery('#noteInput, #chat-textarea').val('');
      if (action.payload != null) {
        // selectedFirst(state.selected_feedback);
        //detailToTop();
        clearChatAttachments();
      }
      chatDown();
    },
    deselectFeedback: function (state, action) {
      state.selected_feedback = null;
      state.feedback_detail = null;
      state.alert.alert = false;
      jQuery('#noteInput, #chat-textarea').val('');
      clearChatAttachments();
    },
    updateSelectedFeedback: function (state, action) {
      state.alert.alert = false;
      if (jQuery('.feedback-list').length < 1) {
        window.location.href =
          "/business/" +
          action.payload.feedback[0].business_id +
          "/feedbacks/?selected=" +
          action.payload.feedback[0].id;
      }
      if (
        state.business &&
        state.business.business_id === action.payload.feedback[0].business_id
      ) {
        if (state.initial_feedbacks != null) {
        } else {
          state.initial_feedbacks = [];
        }
        var found = false;
        for (var i = 0; i < state.initial_feedbacks.length; i++) {
          if (state.initial_feedbacks[i].id === action.payload.feedback[0].id) {
            found = true;
            break;
          }
        }
        if (found === true) {
          state.selected_feedback = action.payload.feedback[0].id;
          selectedFirst(state.selected_feedback);
        } else {
          state.selected_feedback = action.payload.feedback[0].id;
          var arr = state.initial_feedbacks;
          arr.unshift(action.payload.feedback[0]);
          state.initial_feedbacks = arr;
        }
      } else {
        window.location.href =
          "/business/" +
          action.payload.feedback[0].business_id +
          "/feedbacks/?selected=" +
          action.payload.feedback[0].id;
      }
    },
    updateSelectedFeedbackNoRedirect: function (state, action) {
      state.alert.alert = false;
      var found = false;
      for (var i = 0; i < state.initial_feedbacks.length; i++) {
        if (state.initial_feedbacks[i].id === action.payload.feedback[0].id) {
          found = true;
          break;
        }
      }
      if (found === true) {
        state.selected_feedback = action.payload.feedback[0].id;
        selectedFirst(state.selected_feedback);
      }
    },
    updateStatusInList: function (state, action) {
      var id = action.payload.body.feedback_id;
      var index = findWithAttr(state.initial_feedbacks, "id", parseInt(id));
      if (index !== false) {
        state.initial_feedbacks[index].status = action.payload.body.status;
      }
    },
    prependFeedbackList: function (state, action) {
      let business_ids = null;
      if (state.businesses) {
        business_ids = [];
        for (var i in state.businesses) {
          business_ids.push(state.businesses[i].business_id);
        }
        let business_ids = business_ids;
      }

      if (
        (state.business && state.business.business_id === action.payload.feedback[0].business_id)
        ||
        (business_ids && business_ids.includes(action.payload.feedback[0].business_id))
      ) {
        if (state.status === window.feedbackStatus.Open.value || state.status == null || state.status === "null" || state.status === "All") {
          if (state.initial_feedbacks != null) {
          } else {
            state.initial_feedbacks = [];
          }
          var arr = state.initial_feedbacks;
          var index = findWithAttr(arr, "id", parseInt(action.payload.feedback[0].feedback_id));
          if (index === false) {
            arr.unshift(action.payload.feedback[0]);
            state.initial_feedbacks = arr;
          }
        }
      } else {
        //window.location.href = "/business/"+action.payload.feedback[0].business_id+"/feedbacks/?selected="+action.payload.feedback[0].id;
      }
    },
    updateFeedbackResponseTime: function (state, action) {
      var payload = JSON.parse(action.payload);
      if (
        state.feedback_detail &&
        state.feedback_detail.feedback_id === payload.feedback_id
      ) {
        state.feedback_detail.response_time = payload.response_time;
      }
    },
    setFeedbackDetail: function (state, action) {
      state.feedback_detail = action.payload;
      state.loading = false;
      updateVideos();
    },
    setFeedbackDetailPagination: function (state, action) {
      if (state.feedback_detail != null) {
        let paginator = new Paginator(state.initial_feedbacks);
        const prevObject = paginator.previous(state.feedback_detail.feedback_id);
        const nextObject = paginator.next(state.feedback_detail.feedback_id);
        state.feedback_detail.prev_id = prevObject ? prevObject.id : null;
        state.feedback_detail.next_id = nextObject ? nextObject.id : null;
      }
    },
    setFeedbacksCount: function (state, action) {
      const filterFeedbacksCount = JSON.parse(window.localStorage.getItem('filterFeedbacksCount')) ?? {
        "feedbackCountDetails": {
          "countOpen": 0,
          "countPending": 0,
          "countResolved": 0,
          "countAll": 0,
          "countRatingsOnly": 0
        },
        "hasPriorities": {
          "Resolved": {},
          "All": {},
          "Pending": {},
          "Open": {},
          "RatingsOnly": {}
        }
      };

      let mergedFilterFeedbacksCount = {
        ...filterFeedbacksCount,
        ...action.payload.filterFeedbacksCount
      }
      state.filterFeedbacksCount = mergedFilterFeedbacksCount;
      window.localStorage.setItem("filterFeedbacksCount", JSON.stringify(state.filterFeedbacksCount));
    },
    setFeedbackList: function (state, action) {
      state.initial_feedbacks = action.payload;
    },
    appendFeedbackList: function (state, action) {
      for (var i in action.payload) {
        state.initial_feedbacks.push(action.payload[i]);
      }
    },
    setFeedbackAlert: function (state, action) {
      state.alert = {
        alert: action.payload.alert,
        alert_class: action.payload.alert.alert_class,
        alert_message: action.payload.alert.alert_message,
        alert_location: action.payload.alert.alert_location ?? null,
      };
    },
      setResponseSuggestion: function (state, action) {
          state.responseSuggestion = action.payload;
          state.errorResponseSuggestion = null;
      },
      errorResponseSuggestion: function (state, action) {
          state.responseSuggestion = null;
          state.errorResponseSuggestion = action.payload;
          state.loading = false;
      },
    setMaskedCall: function (state, action) {
      state.proxyService = action.payload;
      state.loading = false;
    },
    clearMaskedCallProxy: function (state, action) {
      state.proxyService = null;
    },
    setAssignEmployee: function (state, action) {
      state.loading = false;
      state.employee = action.payload;
      if (parseInt(action.payload.feedback_id) === parseInt(state.feedback_detail.feedback_id)) {
        state.feedback_detail.assigned_to = action.payload.assigned_to;
      }
    },
    setAssignRatingPageEmployee: function (state, action) {
      state.loading = false;
      state.ratingPageEmployee = action.payload;
      if (parseInt(action.payload.feedback_id) === parseInt(state.feedback_detail.feedback_id)) {
        state.feedback_detail.ratingPageEmployee = action.payload.ratingPageEmployee;
      }
    },
    updateAttachments: function (state, action) {
      if (state.feedback_detail.feedback_id === parseInt(action.payload.feedback_id)) {
        if (state.feedback_detail.feedback_attachments == null) {
          state.feedback_detail.feedback_attachments = [action.payload.attachments];
        }
        state.feedback_detail.feedback_attachments = action.payload.attachments;
      }
    },
    setFeedbackFromBody: function (state, action) {
      state.feedback_detail = action.payload.body;
    },
    updateModalContent: function (state, action) {
      state.modal = action.payload;
      state.selected_feedback_modal = action.payload.selected_feedback_modal;
    },
    updateOnlineUsers: function (state, action) {
      if (state.online_users) {
        var users = [];
        var order = [];
        for (var i = 0; i < state.online_users.length; i++) {
          var user = state.online_users[i];
          var web = (user.last_web_activity ? Date.parse(user.last_web_activity + " UTC") : 0);
          var api = (user.last_api_activity ? Date.parse(user.last_api_activity + " UTC") : 0);
          var greater = ((web > api) ? web : api);
          user.greater = greater;
          users.push(user);
        }
        users.sort((a, b) => (a.greater > b.greater) ? -1 : (a.greater === b.greater) ? ((a.firstname > b.firstname) ? -1 : 1) : 1);
        state.online_users = users;
      }
    },
    addEmailForward: function (state, action) {
      state.current_email_forwards.push(action.payload);
      // console.log(state, action)
    },
    removeEmailForward: function (state, action) {
      var removeIndex = -1;
      state.current_email_forwards
        .forEach(function (item, index) {
          if (item.email === action.payload.email) {
            removeIndex = index;
          }
        })
      state.current_email_forwards.splice(removeIndex, 1);
    },
    addForward: function (state, action) {
      state.current_forwards.push(action.payload);
    },
    removeForward: function (state, action) {
      var removeIndex = state.current_forwards
        .map(function (item) {
          return item.id;
        })
        .indexOf(37);
      state.current_forwards.splice(removeIndex, 1);
    },

    /* new forward modal */
    addForwardContact: function (state, action) {
      state.all_forwards.push(action.payload);
    },

    removeForwardContact: function (state, action) {
      var removeIndex = -1;
      state.all_forwards
        .forEach(function (item, index) {
          if (item.email === action.payload.email) {
            removeIndex = index;
          }
          if (item.recipient === action.payload.recipient) {
            removeIndex = index;
          }
        })
      state.all_forwards.splice(removeIndex, 1);
    },

    toggleAddToContacts: function (state, action) {
      // Find the index of the entry with the same nickname, if it exists
      const existingIndex = state.all_forwards.findIndex(item => item.nickname === action.payload.nickname);

      // If the entry exists, update its addToContacts value
      if (existingIndex !== -1) {
          const updatedEntry = {
              ...state.all_forwards[existingIndex],
              addToContacts: action.payload.addToContacts
          };
          // Update the entry in the array
          state.all_forwards[existingIndex] = updatedEntry;
      }
      // If the entry doesn't exist, do nothing
    },

    resetAllForwards: function (state, action) {
      state.all_forwards = [];
    },

    resetCurrentForwards: function (state, action) {
      state.current_forwards = [];
    },

    resetCurrentEmailForwards: function (state, action) {
      state.current_email_forwards = [];
    },
    setSelectedNote: function (state, action) {
      state.selected_note = action.payload;
      state.selected_note_text = action.payload.note.note;
    },
    setFeedbackCount: function (state, action) {
      state.feedback_count = action.payload;
    },
    setPaginateCount: function (state, action) {
      state.paginate_count = action.payload;
    },
    setNoteText: function (state, action) {
      state.selected_note_text = action.payload;
    },
    updateTotals: function (state, action) {
      state.totals = action.payload;
    },
    updateOldestPending: function (state, action) {
      state.oldest_pending = action.payload;
    },
    updateTable: function (state, action) {
      state.stats_table = action.payload;
    },
    setFilterStatus: function (state, action) {
      state.status = action.payload;
    },
    setFilterTimeframe: function (state, action) {
      state.timeframe = action.payload;
    },
    setLoading: function (state, action) {
      state.loading = action.payload.loading;
      state.loading_location = action.payload.location;
      state.loading_data = action.payload.data;
    },
    resetFeedbackPrompt: function (state, action) {
        state.feedbackPrompt = null
    },
    setChatAnyway: function (state, action) {
      state.chatAnyway = action.payload.chatAnyway;
    },
    setCustomTimeframe: function (state, action) {
      state.timeframe_next = action.payload.next;
      state.timeframe_prev = action.payload.prev;
    },
    setCurrentCursors: function (state, action) {
      state.next_cursor = action.payload.next_cursor;
      state.prev_cursor = action.payload.prev_cursor;
    },
    setCurrentPage: function (state, action) {
      state.current_page = action.payload;
      if (state.current_page <= 1) {
        state.current_page = 1;
      }
    },
    setFeedbackStatus: function (state, action) {
      state.status = action.payload;
    },
    setTotalPages: function (state, action) {
      state.total_pages = action.payload;
    },
    setLastestTime: function (state, action) {
      state.lastest_time = action.payload;
    },
    setQuery: function (state, action) {
      state.query = action.payload;
    },
    setChatQuery: function (state, action) {
      state.query = action.payload;
    },
    handleNoteResponse: function (state, action) {

      if (action.payload
        && state.feedback_detail
        && action.payload.feedback_id === state.feedback_detail.feedback_id) {
        var n = [];
        for (var i in state.feedback_detail.notes) {
          n.push(state.feedback_detail.notes[i].notes_id);
        }
        if (!n.includes(parseInt(action.payload.note.notes_id))) {
          state.feedback_detail.notes.push(action.payload.note);
        }
      }
    },
    handleStatusUpdate: function (state, action) {
      refreshOpenFeedbacksBadge(action.payload.open);
    },
    handleStatusHistoryResponse: function (state, action) {
      if (action.payload
        && state.feedback_detail
        && action.payload.feedback_id === state.feedback_detail.feedback_id) {
        var n = [];
        for (var i in state.feedback_detail.status_history) {
          n.push(state.feedback_detail.status_history[i].id);
        }
        if (!n.includes(parseInt(action.payload.history.id))) {
          state.feedback_detail.status_history.unshift(action.payload.history);
        }
      }
    },
    handleNoteUpdateResponse: function (state, action) {
      if (action.payload
        && state.feedback_detail
        && action.payload.feedback_id === state.feedback_detail.feedback_id) {
        var n = [];
        for (var i in state.feedback_detail.notes) {
          if (state.feedback_detail.notes[i].notes_id === action.payload.note.notes_id) {
            state.feedback_detail.notes[i] = action.payload.note;
          }
        }
      }
    },
    handleStatusHistoryUpdateResponse: function (state, action) {
      if (action.payload
        && state.feedback_detail
        && action.payload.feedback_id === state.feedback_detail.feedback_id) {
        var n = [];
        for (var i in state.feedback_detail.status_history) {
          if (state.feedback_detail.status_history[i].id === action.payload.history.id) {
            state.feedback_detail.status_history[i] = action.payload.history;
          }
        }
      }
    },
    handleFeedbackRead: function (state, action) {
      if (action.payload.feedback_id === state.selected_feedback) {
        var index = findWithAttr(state.feedback_detail.reads, "id", parseInt(action.payload.id));
        if (index === false) {
          state.feedback_detail.reads.unshift(action.payload);
        }
      }
    },
    handleUserActivityUpdateResponse: function (state, action) {
      if (state.online_users) {
        var index = findWithAttr(state.online_users, "user_id", parseInt(action.payload.user_id));
        var user = null;
        if (index !== false) {
          user = state.online_users[index];
          user.last_web_activity = action.payload.last_web_activity;
          user.last_api_activity = action.payload.last_api_activity;
          var element = state.online_users[index];
          state.online_users.splice(index, 1);
          state.online_users.splice(0, 0, element);
        } else {
          if (action.payload.current_user !== state.current_user) {
            user = {};
            user.user_id = action.payload.user_id;
            user.firstname = action.payload.firstname;
            user.lastname = action.payload.lastname;
            user.last_web_activity = action.payload.last_web_activity;
            user.last_api_activity = action.payload.last_api_activity;
            user.is_logout = action.payload.is_logout;
            state.online_users.unshift(user);
          }
        }
      }
    },
    handleMessageAttachment: function (state, action) {
      if (action.payload.feedback_id === state.selected_feedback) {
        let chat = state.feedback_detail.chats.find(chat => chat.provider_message_id === action.payload.provider_message_id);
        chat.attachments.push(action.payload.attachment);
      }
    },
    handleFeedbackPromptUpdate: function (state, action) {
      if (state.loading_data && action.payload.payload.feedbackId !== state.loading_data.feedbackId) {
        return;
      }

      if (action.payload.payload.feedbackId !== state.selected_feedback || !state.loading)
          return;

      state.loading = false;
      state.loading_location = null;
      state.loading_data = null;
      state.value = action.payload.payload.feedbackPrompt.promptOutput;
      state.feedbackPrompt = action.payload.payload.feedbackPrompt.promptOutput;
    },
      handleMessageResponse: function (state, action) {
          if (action.payload.feedback_id === state.selected_feedback) {
              state.feedback_detail.chats = state.feedback_detail.chats || [];

              const chat_ids = state.feedback_detail.chats.map(chat => chat.id);

              if (!chat_ids.includes(action.payload.id)) {
                  state.feedback_detail.chats.push(action.payload);
              }

              if (state.feedback_detail && !action.payload.auto_response) {
                  state.feedback_detail.chat_status = "Chat Started";
              }

              state.loading = false;
              state.loading_location = "chat";

              chatDown();
          } else {
              console.log('Feedback ID does not match');
          }

          if (state.initial_feedbacks) {
              let index = findWithAttr(state.initial_feedbacks, "id", parseInt(action.payload.feedback_id));

              if (index !== false) {
                  state.initial_feedbacks[index].created_at = action.payload.created_at;
                  state.initial_feedbacks[index].chat_status = "Chat Started";
                  if (state.feedback_detail) {
                      state.initial_feedbacks[index].response_time = state.feedback_detail.response_time;
                  } else {
                      let before = new Date(state.initial_feedbacks[index].created_at_timestamp);
                      let after = new Date(action.payload.created_at);
                      let diff = new Date(after - before); // milliseconds between now & Christmas

                      let responsetime = diff.getMinutes() + "m " + diff.getSeconds() + "s";
                      state.initial_feedbacks[index].response_time = {responsetime};
                  }

                  if (state.initial_feedbacks[index].latest) {
                      state.initial_feedbacks[index].latest.message = action.payload.message;
                  }
                  if (state.initial_feedbacks[index].userstring) {
                      state.initial_feedbacks[index].userstring = userstring;
                  }
              }
          }
      },
    handleRatingResponse: function (state, action) {
      if (action.payload.feedback_id === state.selected_feedback) {
        state.loading_location = "page";
        state.feedback_detail.rating = action.payload.feedback.rating;
        state.feedback_detail.ratethisbizrating = action.payload.feedback.ratethisbizrating;
        state.feedback_detail.ratethisbizclicks = action.payload.feedback.ratethisbizclicks;
        state.loading = false;
      }

      if (state.initial_feedbacks) {
        var index = findWithAttr(state.initial_feedbacks, "id", parseInt(action.payload.feedback_id));
        if (index !== false) {
          state.initial_feedbacks[index].ratethisbiz_rating = action.payload.feedback.rating.rating;
        }
      }
    },
    handleFeedbackGeolocationUpdated: function (state, action) {
      if (action.payload.payload.feedbackId === state.selected_feedback) {
        state.loading_location = "page";
        state.feedback_detail.geolocation = action.payload.payload.geolocation;
        state.loading = false;
      }

      if (state.initial_feedbacks) {
        var index = findWithAttr(state.initial_feedbacks, "id", parseInt(action.payload.payload.feedbackId));
        if (index !== false) {
          state.initial_feedbacks[index].geolocation = action.payload.payload.geolocation;
        }
      }
    },
    getState: function (state, action) {
      var obj = {
        title: state.title,
        business: (state.business ? state.business.business_id : null),
        businessHasAutoPilot: state.businessHasAutoPilot,
        businessHasWebWidget: state.businessHasWebWidget,
        selected_feedback: state.selected_feedback,
        current_user: state.current_user,
        timeframe: state.timeframe,
        timeframe_next: state.timeframe_next,
        timeframe_prev: state.timeframe_prev,
        other_filter: state.other_filter,
        status: state.status,
        current_page: state.current_page,
        query: state.query,
        region: (state.region ? state.region.id : null),
        region_type: state.region_type,
        department_ids: state.department_ids,
        custom_qr_code: state.custom_qr_code ?? null,
        tellmyco_id: state.tellmyco_id ?? null,
        include_user: state.include_user ?? false,
        archive: state.archive ?? false,
        paginate_count: state.paginate_count ?? 10,
        sorting: state.sorting ?? null,
        business_sorting: state.business_sorting ?? null
      };
      var ids = [];
      var depts = [];
      if (state.department_ids) {
        for (var i in state.department_ids) {
          depts.push(state.department_ids[i]);
        }
        obj.department_ids = depts;
      }
      if (state.businesses) {
        for (var i in state.businesses) {
          ids.push(state.businesses[i].business_id);
        }
        obj.b = ids;
      } else {
        obj.b = state.business.business_id;
      }
      window.stateObject = obj;
    },
    handleUserTyping: function (state, action) {
      if (action.payload.feedback_id == state.selected_feedback && (window.instance_uuid != action.payload.instance_uuid)) {
        if (JSON.parse(action.payload.status) == true) {
          state.typing_timer = 8;
          state.typing_name = action.payload.user.user_name;
          state.typing_user_id = action.payload.user.user_id;
          state.typing_is_business = action.payload.user.is_business;
        } else {
          state.typing_timer = 0;
          state.typing_name = null;
          state.typing_user_id = null;
          state.typing_is_business = null;
        }
        chatDown();
      }
    },
    decrementTimer: function (state, action) {
      if (state.typing_timer > 0) {
        state.typing_timer -= 1;
      } else {
        state.typing_timer = 0;
        state.typing_name = null;
        state.typing_user_id = null;
        state.typing_is_business = null;
      }
    },
    IncrementSearchTyping: function (state, action) {
      if (action.payload == true) {
        state.search_typing_timer = 1;
      }
    },
    decrementSearchTimer: function (state, action) {
      if (state.search_typing_timer > 0) {
        state.search_typing_timer -= 0.5;
      } else {
        state.search_typing_timer = 0;
      }
    },
    setNotificationPermission: function (state, action) {
      state.notification_permission = action.payload;
    },
    setOtherFilter: function (state, action) {
      state.other_filter = action.payload;
    },
    addEmailRecipient: function (state, action) {
      state.email_recipients.push({
        value: action.payload.email_address,
        description: action.payload.name,
        uuid: uuid.v4()
      });
    },
    addEmailKeywordRecipient: function (state, action) {
      state.email_recipients.push({
        email: action.payload.email,
        recipient_name: (action.payload.name ? action.payload.name : (action.payload.firstname + " " + action.payload.lastname).trim()),
        uuid: uuid.v4()
      });
    },
    removeEmailRecipient: function (state, action) {
      state.email_recipients = state.email_recipients.filter(
        item => item.uuid != action.payload.uuid
      );
    },
    addPhoneRecipient: function (state, action) {
      state.phone_recipients.push({
        value: action.payload.phone,
        description: action.payload.name,
        uuid: uuid.v4()
      });
    },
    addSMSKeywordRecipient: function (state, action) {
      state.phone_recipients.push({
        phone: cleanPhone(action.payload.phone),
        recipient_name: (action.payload.name ? action.payload.name : (action.payload.firstname + " " + action.payload.lastname).trim()),
        uuid: uuid.v4()
      });
    },
    removePhoneRecipient: function (state, action) {
      state.phone_recipients = state.phone_recipients.filter(
        item => item.uuid != action.payload.uuid
      );
    },
    addPrecanned: function (state, action) {
      state.precanned.push({
        id: null,
        label: "",
        text: "",
        creation_date: null,
        created_by: null,
        business_id: state.business.business_id,
        uuid: uuid.v4(),
        label_error: false,
        text_error: false
      });
    },
    editPrecanned: function (state, action) {
      var index = findWithAttr(state.precanned, 'uuid', action.payload.uuid);
      if (action.payload.type == 'label') {
        state.precanned[index].label = action.payload.text;
      } else if (action.payload.type == 'text') {
        state.precanned[index].text = action.payload.text;
      } else {
        state.precanned[index][action.payload.type] = action.payload.text;
      }
    },
    deletePrecanned: function (state, action) {
      var index = findWithAttr(state.precanned, 'uuid', action.payload.uuid);
      state.precanned.splice(index, 1);
    },
    addAutoresponseKeyword: function (state) {
      state.autoresponseKeywords.push({
        id: null,
        keyword: "",
        response: "",
        creation_date: null,
        created_by: null,
        business_id: state.business.business_id,
        uuid: uuid.v4(),
        keyword_error: false,
        response_error: false
      });
    },
    editAutoresponseKeyword: function (state, action) {
      const index = findWithAttr(state.autoresponseKeywords, 'uuid', action.payload.uuid);
      state.autoresponseKeywords[index][action.payload.type] = action.payload.text;
    },
    deleteAutoresponseKeyword: function (state, action) {
      const index = findWithAttr(state.autoresponseKeywords, 'uuid', action.payload.uuid);
      state.autoresponseKeywords.splice(index, 1);
    },
    addTags: function (state, action) {
      state.business_tags.push({
        id: null,
        label: "",
        is_active: 1,
        created_at: null,
        updated_at: null,
        business_id: state.business.business_id,
        uuid: uuid.v4(),
      });
    },
    editTags: function (state, action) {
      var index = findWithAttr(state.business_tags, 'uuid', action.payload.uuid);
      state.business_tags[index].label = action.payload.text;
    },
    deleteTags: function (state, action) {
      var index = findWithAttr(state.business_tags, 'uuid', action.payload.uuid);
      state.business_tags.splice(index, 1);
    },
    errorTags: function (state, action) {
      var index = findWithAttr(state.business_tags, 'uuid', action.payload.uuid);
      state.business_tags[index].error = action.payload.text;
    },
    addForwards: function (state, action) {
      state.business_forwards.push({
        id: null,
        recipient: "",
        nickname: "",
        active: 1,
        custom_text: null,
        created_at: null,
        updated_at: null,
        type: "SMS",
        feedback_id: null,
        user_id: null,
        uuid: uuid.v4(),
      });
    },
    editForwards: function (state, action) {
      var index = findWithAttr(state.business_forwards, 'uuid', action.payload.uuid);
      if (action.payload.type == 'recipient') {
        state.business_forwards[index].recipient = action.payload.text;
      } else if (action.payload.type == 'nickname') {
        state.business_forwards[index].nickname = action.payload.text;
      } else if (action.payload.type == 'email') {
        state.business_forwards[index].email = action.payload.text;
      }
      else if (action.payload.type == 'recipient_error') {
        state.business_forwards[index].recipient_error = action.payload.text;
      }
    },
    deleteForwards: function (state, action) {
      var index = findWithAttr(state.business_forwards, 'uuid', action.payload.uuid);
      state.business_forwards.splice(index, 1);
    },
    updateCheckedFeedbacks: function (state, action) {
      if (action.payload === 'all') {
        let all_ids = [];
        for (const fb in state.initial_feedbacks) {
          let item = state.initial_feedbacks[fb];
          all_ids.push(item.id);
        }
        state.checked_feedbacks = all_ids;
      } else if (action.payload === "none") {
        state.checked_feedbacks = [];
      } else {
        let id = action.payload;
        state.checked_feedbacks.includes(id) ? state.checked_feedbacks.splice(state.checked_feedbacks.indexOf(action.payload), 1) : state.checked_feedbacks.push(action.payload);
      }
    },
    setSorting: function (state, action) {
      state.sorting = action.payload;
      window.localStorage.setItem("sorting", action.payload);
    },
    setBusinessSorting: function (state, action) {
      state.business_sorting = action.payload;
      window.localStorage.setItem("business_sorting", action.payload);
    },
    setPriority: function (state, action) {

      // this is for feedback listing
      try {
        if (state.initial_feedbacks && action.payload.priority) {
          let index = findWithAttr(state.initial_feedbacks, "id", parseInt(action.payload.feedback_id));
          if (index !== false) {
            state.initial_feedbacks[index].priority = action.payload.priority;
          }
        }
      } catch (e) {
        console.log(e.toString());
      }

      //this is fr feedback detail page
      try {
        if (state.feedback_detail.priority && action.payload.priority && state.feedback_detail.priority !== action.payload.priority) {
          state.feedback_detail.priority = action.payload.priority;
        }
      } catch (e) {
        console.log(e.toString());
      }
    },
    setBusinessDepartmentCount: function (state, action) {
      state.businessDepartmentCount = action.payload;
    },
  }
});

//Async Functions:
export function ajaxFeedback(id, successcallback) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
    return jQuery.ajax("/feedback/" + id + "/ajax").then(
      (success) => {
        dispatch(setLoading({ loading: false, location: 'feedbackSection' }));
        dispatch(setFeedbackDetail(JSON.parse(success)));
        dispatch(setFeedbackDetailPagination());
        chatDown();
        if (typeof successcallback == "function") {
          successcallback();
        }
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxFeedbackListSingle(feedback_id) {
  return function (dispatch) {
    return jQuery.ajax("/feedback/" + feedback_id + "/ajax/single").then(
      (success) => {
        dispatch(updateSelectedFeedback(success));
        dispatch(ajaxFeedback(feedback_id));
        dispatch(setLoading({ loading: false, location: 'page' }));
        chatDown();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxFeedbackListSingleNoRedirect(feedback_id) {
  return function (dispatch) {
    return jQuery.ajax("/feedback/" + feedback_id + "/ajax/single").then(
      (success) => {
        dispatch(updateSelectedFeedbackNoRedirect(success));
        dispatch(ajaxFeedback(feedback_id));
        dispatch(setLoading({ loading: false, location: 'page' }));
        chatDown();
      },
      (error) => console.log(error),
    );
  };
}

export function simpleUpdateTable() {
  return function (dispatch) {
    dispatch(getState());
    dispatch(ajaxFeedbackFilterV2(true, true))
  }
}

export function simpleUpdateTableForStatus() {
  return function (dispatch) {
    dispatch(getState());
    dispatch(ajaxFeedbackFilterForStatusUpdate(window.stateObject.timeframe, window.stateObject.status, window.stateObject.selected_feedback, window.stateObject.b, window.stateObject.page, window.stateObject.total, window.stateObject.query, window.stateObject.other_filter, window.stateObject.archive, window.stateObject.department_ids ?? null, window.stateObject.region_id ?? null, window.stateObject.region_type ?? null, true));
  }
}

export function ajaxPrependFeedbackList(feedback_id) {
  return function (dispatch) {
    return jQuery.ajax("/feedback/" + feedback_id + "/ajax/single").then(
      (success) => {
        dispatch(prependFeedbackList(success));
        dispatch(simpleUpdateTable());
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxFeedbackFilterV2(loading = true, returnFeedbacksCount = null) {
  return function (dispatch) {

    dispatch(setLoading({ loading: loading, location: 'feedbackSection' }));
    dispatch(getState());
    let state = window.stateObject;
    let data = {
      business_id: state.business,
      timeframe: state.timeframe,
      status: state.status,
      search: state.query,
      archive: state.archive ? 1 : 0,
      department_ids: state.department_ids,
      tellmyco_id: state.tellmyco_id,
      include_user: state.include_user ? 1 : 0,
      custom_qr_code: state.custom_qr_code,
      page: state.current_page,
      paginate_count: state.paginate_count,
      timeframe_next: state.timeframe_next,
      timeframe_prev: state.timeframe_prev,
      sorting: validateFeedbackSorting(state.sorting),
      other: window.chat_status ?? state.other_filter,
      returnFeedbacksCount: returnFeedbacksCount,
      filterQrCode: getQrCodeFilter(),
      filterWebToText: getWebToTextFilter(),
      filterNotWebToText: getNotWebToTextFilter()
    }

    if (getRatingsFilter() !== null && getRatingsFilter() !== 'undefined') {
        data.filterRating = getRatingsFilter();
    }

    if (getDepartmentFilter() !== null && getDepartmentFilter() !== 'undefined') {
        data.filterDepartment = getDepartmentFilter();
    }

    if (getTagFilter() !== null && getTagFilter() !== 'undefined') {
        data.filterTag = getTagFilter();
    }

    let api_url = "/v2/feedbacks/" + state.business + "/filter";

    return jQuery.ajax({ url: api_url, data: data }).then(
      (success) => {
        var json_success = JSON.parse(success);
        dispatch(setFeedbackList(json_success.initial_feedbacks));
        dispatch(setTotalPages(json_success.total_pages));
        dispatch(setFilterStatus(json_success.status));
        dispatch(setFilterTimeframe(json_success.timeframe));
        dispatch(setFeedbackCount(json_success.feedback_count));
        dispatch(setLoading({ loading: false, location: 'feedbackSection' }));
        dispatch(setSorting(json_success.sorting));
        dispatch(setBusinessDepartmentCount(json_success.businessDepartmentCount));
        dispatch(setFeedbackDetailPagination());
        dispatch(setLastestTime(json_success.lastest_time));
        if (returnFeedbacksCount) {
          dispatch(setFeedbacksCount(json_success));
        }
        // reinitializeTable();
      },
      (error) => console.log(error),
    );
  }
}

export function ajaxChatFilterV2() {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
    dispatch(getState());
    let state = window.stateObject;
    let data = {
      business_id: state.business,
      timeframe: state.timeframe,
      status: state.status,
      search: state.query,
      other: state.other_filter,
      archive: state.archive ? 1 : 0,
      department_ids: state.department_ids,
      tellmyco_id: state.tellmyco_id,
      include_user: state.include_user ? 1 : 0,
      custom_qr_code: state.custom_qr_code,
      page: state.current_page,
      paginate_count: state.paginate_count,
      prev: state.timeframe_prev,
      next: state.timeframe_next,
      sorting: state.sorting,
    }

    let api_url = "/v2/chat/filter";
    dispatch(setLoading({ loading: true, location: 'search' }));

    return jQuery.ajax({ url: api_url, data: data }).then(
      (success) => {
        var json_success = JSON.parse(success);
        dispatch(setFeedbackList(json_success.initial_feedbacks));
        dispatch(setTotalPages(json_success.total_pages));
        dispatch(setFilterStatus(json_success.status));
        dispatch(setFilterTimeframe(json_success.timeframe));
        dispatch(setFeedbackCount(json_success.feedback_count));
        dispatch(setLoading({ loading: false, location: 'search' }));
        // reinitializeTable();
      },
      (error) => console.log(error),
    );
  }
}

export function ajaxFeedbackFilter(timeframe, status, feedback_id, business_id, page, total, query, other, archive, department_ids = null, region_id = null, region_type = null, set_selected = true) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'stats' }));
    var ajax_query = "/feedback/list/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "");
    if (window.is_super_user) {
      ajax_query = "/feedback/superuser-list/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "");
    }
    if (window.tellmyco_id) {
      ajax_query += "&tellmyco_id=" + window.tellmyco_id;
    }
    if (window.custom_qr_code) {
      ajax_query += "&custom_qr_code=" + window.custom_qr_code;
    }
    return jQuery.ajax(ajax_query).then(
      (success) => {
        var json_success = JSON.parse(success);
        dispatch(setCurrentCursors({
          next_cursor: json_success.next_cursor,
          prev_cursor: json_success.prev_cursor
        }));
        dispatch(setTotalPages(JSON.parse(success).total_pages));
        dispatch(setFilterStatus(JSON.parse(success).status));
        dispatch(setFilterTimeframe(JSON.parse(success).timeframe));
        dispatch(updateTotals(JSON.parse(success).totals));
        dispatch(updateTable(JSON.parse(success).stats_table));
        dispatch(updateOldestPending(JSON.parse(success).oldest_pending));
        dispatch(setFeedbackList(JSON.parse(success).initial_feedbacks));
        if (set_selected) {
          dispatch(setSelectedFeedback((JSON.parse(success).feedback_detail != null ? JSON.parse(success).feedback_detail.feedback_id : null)));
          dispatch(setFeedbackDetail(JSON.parse(success).feedback_detail));
        }
        dispatch(setLoading({ loading: false, location: 'stats' }));
        // reinitializeTable();
      },
      (error) => console.log(error),
    );
  }
}

export function refreshOpenFeedbacksBadge(n) {
  const el = document.querySelector('[data-selector-element="open-feedbacks-badge"]');
  if (n > 0) {
    el.classList.remove('hidden');
    el.textContent = n;
  } else {
    el.classList.add('hidden');
  }
}

export function ajaxFeedbackFilterForStatusUpdate(timeframe, status, feedback_id, business_id, page, total, query, other, archive, department_ids = null, region_id = null, region_type = null, set_selected = true) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'stats' }));
    var ajax_query = "/feedback/list/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "");
    if (window.is_super_user) {
      ajax_query = "/feedback/superuser-list/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "");
    }
    if (window.tellmyco_id) {
      ajax_query += "&tellmyco_id=" + window.tellmyco_id;
    }
    if (window.custom_qr_code) {
      ajax_query += "&custom_qr_code=" + window.custom_qr_code;
    }
    return jQuery.ajax(ajax_query).then(
      (success) => {
        var json_success = JSON.parse(success);
        dispatch(setCurrentCursors({ next_cursor: json_success.next_cursor, prev_cursor: json_success.prev_cursor }));
        dispatch(setTotalPages(JSON.parse(success).total_pages));
        dispatch(setFilterStatus(JSON.parse(success).status));
        dispatch(setFilterTimeframe(JSON.parse(success).timeframe));
        dispatch(updateTotals(JSON.parse(success).totals));
        dispatch(updateTable(JSON.parse(success).stats_table));
        dispatch(updateOldestPending(JSON.parse(success).oldest_pending));
        dispatch(setFeedbackList(JSON.parse(success).initial_feedbacks));
        if (set_selected) {
          dispatch(setSelectedFeedback((JSON.parse(success).feedback_detail != null ? JSON.parse(success).feedback_detail.feedback_id : null)));
          dispatch(setFeedbackDetail(JSON.parse(success).feedback_detail));
        }
        dispatch(setLoading({ loading: false, location: 'stats' }));
        // reinitializeTable();
      },
      (error) => console.log(error),
    );
  }
}

export function ajaxFeedbackFilterDates(timeframe, status, feedback_id, business_id, page, total, query, other, archive, dateobject, department_ids = null, region_id = null, region_type = null) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'stats' }));
    dispatch(setCustomTimeframe(dateobject));
    var ajax_query = "/feedback/list/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (dateobject ? "&dateobject=" + dateobject.prev + "," + dateobject.next + "" : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "");
    if (window.tellmyco_id) {
      ajax_query += "&tellmyco_id=" + window.tellmyco_id;
    }
    if (window.custom_qr_code) {
      ajax_query += "&custom_qr_code=" + window.custom_qr_code;
    }
    return jQuery.ajax({
      url: ajax_query,
      data: dateobject,
    }).then(
      (success) => {
        dispatch(setCurrentPage(1));
        dispatch(setTotalPages(JSON.parse(success).total_pages));
        dispatch(setFilterStatus(JSON.parse(success).status));
        dispatch(setFilterTimeframe(JSON.parse(success).timeframe));
        dispatch(updateTotals(JSON.parse(success).totals));
        dispatch(updateTable(JSON.parse(success).stats_table));
        dispatch(updateOldestPending(JSON.parse(success).oldest_pending));
        dispatch(setFeedbackList(JSON.parse(success).initial_feedbacks));
        dispatch(setSelectedFeedback((JSON.parse(success).feedback_detail != null ? JSON.parse(success).feedback_detail.feedback_id : null)));
        dispatch(setFeedbackDetail(JSON.parse(success).feedback_detail));
        dispatch(setLoading({ loading: false, location: 'stats' }));
        // reinitializeTable();
      },
      (error) => console.log(error),
    );
  }
}

export function secondsToDhms(seconds, withSeconds = true, showZeroMin = false) {

  seconds = Number(seconds);

  let d = Math.floor(seconds / (3600 * 24));
  let h = Math.floor(seconds % (3600 * 24) / 3600);
  let m = Math.floor(seconds % 3600 / 60);

  let dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
  let hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
  let mDisplay = m > 0 ? m + (m === 1 ? " minute" : " minutes") : "";

  if (showZeroMin && seconds < 60) {
    return '0 minutes';
  }

  if (withSeconds) {
    let s = Math.floor(seconds % 60);
    let sDisplay = s > 0 ? ", " + s + (s === 1 ? " second" : " seconds") : "";

    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

  return dDisplay + hDisplay + mDisplay;
}

export function secondsToBriefDhms(seconds, withSeconds = true, showZeroMin = false) {

  seconds = Number(seconds);

  let d = Math.floor((seconds / (3600 * 24)) % 365);
  let h = Math.floor(seconds % (3600 * 24) / 3600);
  let m = Math.floor(seconds % 3600 / 60);
  let y = Math.floor(seconds / (3600 * 24 * 365));

  let dDisplay = d > 0 ? d + (d === 1 ? "d " : "d ") : "";
  let hDisplay = h > 0 ? h + (h === 1 ? "h " : "h ") : "";
  let mDisplay = m > 0 ? m + (m === 1 ? "m" : "m") : "";
  let yDisplay = y > 0 ? y + (y === 1 ? "y " : "y ") : "";

  if (showZeroMin && seconds < 60) {
    return '0 m';
  }


  return yDisplay + dDisplay + hDisplay + mDisplay;
}

export function updateVideos() {
  jQuery('video').each(function () {
    jQuery(this)[0].load();
  });
}

export function reinitializeTable() {
  if ($('#sortTable').length > 0) {
    var table = $('#sortTable').DataTable(
      {
        "paging": false,
        "info": false,
        "order": [[0, "asc"]],
        "searching": false,
        "destroy": true,
      });
    if (jQuery('body').width() > 1000) {
      // new $.fn.dataTable.FixedHeader( table, {
      //   // options
      // } );
    }
    var super_table = $('#sortTable.super_user').DataTable(
      {
        "paging": false,
        "info": false,
        "order": [[0, "asc"]],
        "searching": true,
        "destroy": true,
        "rowGroup": {
          dataSrc: 0,
          startRender: function (rows, group) {
            var collapsed = !!window.collapsedGroups[group];

            rows.nodes().each(function (r) {
              r.style.display = collapsed ? 'none' : '';
            });

            // Add category name to the <tr>. NOTE: Hardcoded colspan
            return $('<tr/>')
              .append('<td colspan="12">' + group + ': ' + rows.count() + (rows.count() > 1 ? ' Locations' : ' Location') + '</td>')
              .attr('data-name', group)
              .toggleClass('collapsed', collapsed);
          },
          endRender: function (rows, group) {
            var total = rows
              .data()
              .pluck(2)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var open = rows
              .data()
              .pluck(3)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var pending = rows
              .data()
              .pluck(4)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var resolved = rows
              .data()
              .pluck(5)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var chats_requested = rows
              .data()
              .pluck(6)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var chats_started = rows
              .data()
              .pluck(7)
              .reduce(function (a, b) {
                var f = jQuery(jQuery.parseHTML(b)[0]).text();
                f = f.replace(" ", "").split("(")[0];
                f = parseInt(f);
                return a + f;
              }, 0);
            var links_sent = rows
              .data()
              .pluck(8)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var smiley_divisor = 0;
            var smiley_score = rows
              .data()
              .pluck(9)
              .reduce(function (a, b) {
                if (b && b != "No Data") {
                  b = b.split("</i>")[1];
                  b = b.replace(" ", "");
                  b = b.replace("%", "");
                  b = parseInt(b);
                  smiley_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            var score_divisor = 0;
            var score_score = rows
              .data()
              .pluck(10)
              .reduce(function (a, b) {
                if (b && b != "No Data") {
                  b = b.replace(" ", "");
                  b = b.replace("%", "");
                  b = parseInt(b);
                  score_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            var resp_divisor = 0;
            var resp_time = rows
              .data()
              .pluck(11)
              .reduce(function (a, b) {
                if (b["@data-sort"]) {
                  b = parseInt(b["@data-sort"]);
                  resp_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            return $('<tr/>')
              .append('<td>' + group + ' Totals: </td>')
              .append('<td/>')
              .append('<td>' + total + '</td>')
              .append('<td>' + open + '</td>')
              .append('<td>' + pending + '</td>')
              .append('<td>' + resolved + '</td>')
              .append('<td>' + chats_requested + '</td>')
              .append('<td>' + chats_started + '</td>')
              .append('<td>' + links_sent + '</td>')
              .append('<td>' + (smiley_score && smiley_divisor ? (smiley_score / smiley_divisor).toFixed(1) + "%" : 'No Data') + '</td>')
              .append('<td>' + (score_score && score_divisor ? (score_score / score_divisor).toFixed(1) + "%" : 'No Data') + '</td>')
              .append('<td>' + (resp_time && resp_divisor ? secondsToDhms((resp_time / resp_divisor)) : 'No Data') + '</td>')
          },
        }
      });
  }
}

export function ajaxFeedbackStatusFilter(state, status = null, timeframe = null, custom_timeframe = null, other_filter = null, excludeStatistics = null) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'stats' }));
    dispatch(getState());
    let business_id_or_ids = state.business ? state.business.business_id : null;
    if (state.businesses) {
      let ids = [];
      for (let i in state.businesses) {
          ids.push(state.businesses[i].business_id);
      }
      business_id_or_ids = ids;
    }

    let data = {
      business_id: state.business,
      timeframe: timeframe ?? state.timeframe,
      status: status ?? state.status,
      search: state.query,
      archive: state.archive ? 1 : 0,
      department_ids: state.department_ids,
      tellmyco_id: state.tellmyco_id,
      include_user: state.include_user ? 1 : 0,
      custom_qr_code: state.custom_qr_code,
      page: state.current_page,
      paginate_count: state.paginate_count ?? 10,
      timeframe_next: custom_timeframe ? custom_timeframe.next : state.timeframe_next ,
      timeframe_prev: custom_timeframe ? custom_timeframe.prev : state.timeframe_prev,
      sorting: state.sorting,
      business_sorting: state.business_sorting,
      other: other_filter ?? state.other_filter,
      excludeStatistics: excludeStatistics
    }
    var ajax_query = "/feedback/list/" + "false" + "/ajax/" + business_id_or_ids + "/" + data.timeframe + "/" + data.status + (data.page ? "?page=" + data.page : "?page=")
    + (data.search ? "&search=" + data.search : "&search=") + (data.other ? "&other=" + data.other : "") + (data.archive ? "&archive=" + data.archive : "")
    + (data.timeframe_next ? "&dateobject=" + data.timeframe_prev + "," + data.timeframe_next + "" : "") + (data.department_ids ? "&department_ids=" + data.department_ids : "")
    + (data.paginate_count ? "&paginate_count=" + data.paginate_count : "&paginate_count=") + (data.sorting ? "&sorting=" + data.sorting : "&sorting=") +
        (data.business_sorting ? "&business_sorting=" + encodeURIComponent(data.business_sorting) : "&business_sorting=") + (data.excludeStatistics ? "&excludeStatistics=" + data.excludeStatistics : "");
    ajax_query = ajax_query.replace("#", "%23");
    if (window.tellmyco_id) {
      ajax_query += "&tellmyco_id=" + window.tellmyco_id;
    }
    if (window.custom_qr_code) {
      ajax_query += "&custom_qr_code=" + window.custom_qr_code;
    }
    return jQuery.ajax(ajax_query).then(
      (success) => {
        var json_success = JSON.parse(success);
        dispatch(setOtherFilter(json_success.other_filter));
        dispatch(setTotalPages(json_success.total_pages));
        dispatch(setFilterStatus(json_success.status));
        dispatch(setFilterTimeframe(json_success.timeframe));
        dispatch(setFeedbackCount(json_success.feedback_count));
        dispatch(updateTotals(json_success.totals));
        dispatch(updateTable(json_success.stats_table));
        dispatch(updateOldestPending(json_success.oldest_pending));
        dispatch(setSorting(json_success.sorting));
        dispatch(setBusinessDepartmentCount(json_success.businessDepartmentCount));
        dispatch(setFeedbackList(json_success.initial_feedbacks));
        dispatch(setLastestTime(json_success.lastest_time));
        dispatch(setLoading({ loading: false, location: 'stats' }));
        dispatch(setPaginateCount(state.paginate_count ?? 10));
        reinitializeTable()
      },
      (error) => console.log(error),
    );
  }
}

export function ajaxScrollFilter(timeframe, status, feedback_id, business_id, prev_cursor, next_cursor, query, other, archive, department_ids = null, region_id = null, region_type = null) {
  return function (dispatch) {
    if (next_cursor) {
      dispatch(setLoading({ loading: true, location: 'list' }));
      return jQuery.ajax("/feedback/list/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (next_cursor ? "?next_cursor=" + next_cursor : "") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "")).then(
        (success) => {
          const json_success = JSON.parse(success);

          dispatch(appendFeedbackList(json_success.initial_feedbacks));
          dispatch(setCurrentCursors({
            "next_cursor": json_success.next_cursor,
            "prev_cursor": json_success.prev_cursor
          }))
          dispatch(setLoading({ loading: false, location: 'list' }));
        },
        (error) => console.log(error),
      );
    }

  };
}

export function ajaxScrollFilterChat(timeframe, status, feedback_id, business_id, page, total, query, other, archive, department_ids = null, region_id = null, region_type = null) {
  return function (dispatch) {
    if (page && total && page <= total) {
      dispatch(setLoading({ loading: true, location: 'list' }));
      return jQuery.ajax("/feedback/list/chat/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "")).then(
        (success) => {
          dispatch(appendFeedbackList(JSON.parse(success)));
          dispatch(setLoading({ loading: false, location: 'list' }));
        },
        (error) => console.log(error),
      );
    }

  };
}

export function ajaxFeedbackSearch(timeframe, status, feedback_id, business_id, page, total, query, other, archive, department_ids = null, region_id = null, region_type = null) {
  return function (dispatch) {

    dispatch(setLoading({ loading: true, location: 'search' }));
    var ajax_query = "/feedback/list/chat/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + (page ? "?page=" + page : "?page=") + (query ? "&search=" + query : "&search=") + (other ? "&other=" + other : "") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "");
    if (window.tellmyco_id) {
      ajax_query += "&tellmyco_id=" + window.tellmyco_id;
    }
    if (window.custom_qr_code) {
      ajax_query += "&custom_qr_code=" + window.custom_qr_code;
    }
    return jQuery.ajax(ajax_query).then(
      (success) => {
        dispatch(setFeedbackList(JSON.parse(success).initial_feedbacks));
        dispatch(setTotalPages(JSON.parse(success).total_pages));
        if (JSON.parse(success).feedback_detail == null) {
          dispatch(setSelectedFeedback(null));
          dispatch(setFeedbackDetail(null));
        } else {
          dispatch(setSelectedFeedback(JSON.parse(success).feedback_detail.feedback_id));
          dispatch(setFeedbackDetail(JSON.parse(success).feedback_detail));
        }
        dispatch(setLoading({ loading: false, location: 'search' }));
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxChatFeedbackSearch(timeframe, status, feedback_id, business_id, query, archive, department_ids = null, region_id = null, region_type = null) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'search' }));
    return jQuery.ajax("/chat/list/" + feedback_id + "/ajax/" + business_id + "/" + timeframe + "/" + status + "?page=1" + (query ? "&search=" + query : "&search=") + (archive ? "&archive=" + archive : "") + (department_ids ? "&department_ids=" + department_ids : "") + (region_id ? "&region=" + region_id : "") + (region_type ? "&region_type=" + region_type : "")).then(
      (success) => {
        dispatch(setFeedbackList(success.initial_feedbacks));
        dispatch(setTotalPages(success.total_pages));
        if (success.feedback_detail == null) {
          dispatch(setSelectedFeedback(null));
          dispatch(setFeedbackDetail(null));
        } else {
          dispatch(setSelectedFeedback(success.feedback_detail.feedback_id));
          dispatch(setFeedbackDetail(success.feedback_detail));
        }
        dispatch(setLoading({ loading: false, location: 'search' }));
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxCheckedFeedbackStatus(status, state) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
    return jQuery.post("/feedback/ajax/status/multi", {
        checked: state.checked_feedbacks,
        status
    }).then((success) => {
      dispatch(updateCheckedFeedbacks('none'));
      dispatch(ajaxFeedbackFilterV2(true, true))
    })
  }
}

export function ajaxUpdateFeedbackStatus (id, status, state, filterRating = null, filterDepartment = null, filterTag = null) {
  return function (dispatch) {
      return jQuery.post("/feedback/" + id + "/ajax/status/" + status, { data: { feedback_id: id, status: status, instanceUuid: window.instance_uuid } }).then(
      (success) => {

        if (state.feedback_detail != null) {
          dispatch(setFeedbackFromBody(JSON.parse(success)));
          dispatch(setFeedbackAlert(JSON.parse(success)));
          dispatch(updateStatusInList(JSON.parse(success)));
        }
        var ids = [];
        var b = null;
        if (state.businesses) {
          for (var i in state.businesses) {
            ids.push(state.businesses[i].business_id);
          }
          b = ids;
        } else {
          b = state.business.business_id;
        }
        if (state.status === "feedbacker") {
          dispatch(updateStatusInList(JSON.parse(success)));
          return;
        }

        // on MSA business_id is not set
        // handle the state with multiple businesses ids
        if (b && b.length > 1) {
          dispatch(ajaxFeedbackStatusFilter(
            state,
            window.dashboard_filter_status || "all",
            null,
            null,
          ));
        } else {
          if (state.status === null && state.feedback_detail == null) {
            dispatch(ajaxFeedbackFilterV2(false, true))
          } else {
            dispatch(ajaxFeedbackFilterV2(true, true))
          }
        }

        if (state.feedback_detail != null) {
          let loadThisFeedback = state.feedback_detail.next_id || state.feedback_detail.prev_id;

          if (loadThisFeedback !== null) {
            dispatch(setSelectedFeedback(loadThisFeedback));
            dispatch(ajaxFeedback(loadThisFeedback));
          } else {
            dispatch(deselectFeedback());
          }
        }
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxAssignRatingPageEmployee(business_id, feedback_id, rating_page_employee_id) {
    return function (dispatch) {
        dispatch(setLoading({loading: true, location: 'feedbackSection'}));

        return jQuery.post(`/business/${business_id}/feedback/${feedback_id}/rating-page-employee/${rating_page_employee_id}/assign`, {
            data: {
                business_id: business_id,
                feedback_id: feedback_id,
                rating_page_employee_id: rating_page_employee_id,
            }
        }).then(
            (success) => {
                dispatch(setLoading({loading: false, location: 'feedbackSection'}));
                dispatch(setFeedbackFromBody(JSON.parse(success)));
                dispatch(ajaxFeedbackFilterV2(false, true))
                dispatch(setSelectedFeedback(feedback_id));
                dispatch(ajaxFeedback(feedback_id));
                dispatch(setAssignRatingPageEmployee(success));
                dispatch(setFeedbackAlert(JSON.parse(success)));
                showAlert(7000);
            },
            (error) => {
                dispatch(setLoading({loading: false, location: 'feedbackSection'}));
                dispatch(setFeedbackAlert(JSON.parse(error.responseText)));
                showAlert(7000);
                console.log(error.responseText)
            },
        );
    };
}

export function ajaxUpdateFeedbackDepartment(feedback_id, department_id, state, type) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
    return jQuery.post("/feedback/" + feedback_id + "/ajax/department", { data: { feedback_id: feedback_id, department_id: department_id, type: type } }).then(
      (success) => {
        dispatch(setLoading({ loading: false, location: 'feedbackSection' }));
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        var ids = [];
        var b = null;
        if (state.businesses) {
          for (var i in state.businesses) {
            ids.push(state.businesses[i].business_id);
          }
          b = ids;
        } else {
          b = state.business.business_id;
        }
          dispatch(ajaxFeedbackFilterV2(false, true))
          dispatch(setSelectedFeedback(feedback_id));
          dispatch(ajaxFeedback(feedback_id));

          dispatch(setFeedbackAlert(JSON.parse(success)));
          showAlert(7000);
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxArchiveFeedback(id) {
  return function (dispatch) {
    return jQuery.post("/feedback/" + id + "/ajax/archive", { data: { feedback_id: id } }).then(
      (success) => {
        // dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxBlockUser(business_id, feedback_id) {
  return function (dispatch) {
    return jQuery.post("/business/" + business_id + "/feedback/" + feedback_id + "/block").then(
      (success) => {
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxMaskedCall(feedback, isMobile) {
  return function (dispatch) {
    return jQuery.post('/twilio/proxy-service/' + feedback.feedback_id).then(
      (success) => {
        dispatch(setMaskedCall(success));
        const modal_id = "maskedCallHelpModal";
        const modal_title = feedback.is_phone_call ? __('This Feedbacker has requested a phone response') : __('This Feedbacker has NOT requested a phone response');
        const modal_body = "maskedCall";
        const button_1_class = "outline-primary";
        const button_1_id = "cancel";
        const button_1_text = __("Done");
        const button_2_class = "primary";
        const button_2_id = isMobile ? "dialMaskedCall" : null;
        const button_2_text = isMobile ? __("Dial :dial", {':dial': parsePhoneNumberFromString(success.data.proxy).format('NATIONAL')}): null;
        dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxGetAiLastPrompt(feedback) {
    return function (dispatch) {
        return jQuery.get('/feedback/' + feedback + '/ai/last-prompt').then(
            (success) => {
                dispatch(setResponseSuggestion(success));
            },
            (error) => {
                const err = JSON.parse(error.responseText);
                err.code = error.status;
                dispatch(errorResponseSuggestion(err));
            }
        );
    };
}

export function ajaxGenerateAiRecommendedResponse(feedback) {
    return function (dispatch) {
        return jQuery.post('/feedback/' + feedback + '/ai/response-suggestion').then(
            (success) => {
                dispatch(setResponseSuggestion(success));
            },
            (error) => console.log(error),
        );
    };
}

export function ajaxAssignEmployee(feedback, employee, name) {
  return function (dispatch) {
    return jQuery.post('/feedback/' + feedback + '/assign-employee/' + employee + '?instance_uuid=' + window.instance_uuid).then(
      (success) => {
        var alert = { alert: { alert_class: "success", alert_message: `An email and text message notification has been successfully sent to ${name} to let them know they have been assigned this Feedback`,
          alert: true, alert_location: "feedback_detail" } };
        dispatch(setAssignEmployee(success));
        dispatch(setFeedbackAlert(alert));
        setTimeout(() => {
          dispatch(setFeedbackAlert({alert: false, alert_class: null, alert_message: null}));
        }, 7000);
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxFeedbackTags(id, tags) {
  return function (dispatch) {
    return jQuery.post("/feedback/" + id + "/ajax/tags", { data: { tags: tags, feedback_id: id } }).then(
      (success) => {
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        // set details for next/prev
        dispatch(setFeedbackDetailPagination());
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxForwardTexts(feedback_id, user, all_forwards, custom, hide_info) {
  return function (dispatch) {
    // Filter out entries where recipient is null
    const filteredForwards = all_forwards.filter(forward => forward.recipient !== null);

    return jQuery.post("/feedback/" + feedback_id + "/ajax/forward_texts", { data: { feedback_id: feedback_id, user: user, forwards: filteredForwards, custom: custom, hide_info: hide_info } }).then(
      (success) => {
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        dispatch(resetAllForwards({}));
        showAlert();
        dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
        dispatch(ajaxFeedback(feedback_id), function () {
          dispatch(setLoading({ loading: false, location: 'feedbackSection' }));
        });
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxForwardEmails(feedback, feedback_id, user, custom, hide_info, all_forwards) {
  return function (dispatch) {
    return jQuery.post("/feedback/" + feedback_id + "/ajax/forward_emails", { data: { feedback_id: feedback_id, user: user, custom: custom, hide_info: hide_info, recipient: all_forwards ?? [] } }).then(
      (success) => {
        var auth_user = window.auth_user;
        var sender = (feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "Anonymous") + (feedback.is_include_contact && feedback.user.lastname ? " " + feedback.user.lastname + " " : " ");
        var url = (window.manage_server ? window.manage_server : "https://manage.realtimefeedback.com") + "/feedback/" + feedback.feedback_id + "/detail/";
        var mailto_subject = encodeURIComponent(auth_user + __(' has forwarded you a Feedback from ') + sender + "to " + feedback.business.name);

        let mailto_body = `${encodeURIComponent(feedback.description.length > 1000 ? feedback.description.substring(0, 1000) + "..." : feedback.description)}%0D%0A%0D%0A`;

        if(feedback.extra_details.length > 0) {
              mailto_body += 'Additional Info:';
              for (let i =0; i < feedback.extra_details.length; i++) {
                  mailto_body += "%0D%0A" + feedback.extra_details[i].field + ': ' + feedback.extra_details[i].value;
              }
          }
        if (feedback.ratingPageEmployee) {
            mailto_body += "%0D%0A" + "Associated Employee: " + feedback.ratingPageEmployee.name
        }

        mailto_body += "%0D%0A%0D%0A";
        const feedbackCreatedAt = moment.tz(feedback.created_at, feedback.business.call_at_timezone).format("M/D/YYYY, h:mm A z")
        mailto_body += `Feedback submitted by ${sender} to ${feedback.business.name} on ${feedbackCreatedAt} %0D%0A`;
        mailto_body += `Full Feedback details can be viewed here:%0D%0A` + success;

        if (custom) {
          mailto_body = custom + "%0D%0A%0D%0A" +  mailto_body;
        }

        const final_address = `mailto:${all_forwards.map(item=>(item.email)).join(", ")}?subject=` + mailto_subject + "&body=" + mailto_body;
        var emailWindow = window.open(final_address, '_blank');
        emailWindow.focus();
        dispatch(setLoading({ loading: true, location: 'feedbackSection' }));
        dispatch(resetAllForwards({}));
        dispatch(ajaxFeedback(feedback_id), function () {
          dispatch(setLoading({ loading: false, location: 'feedbackSection' }));
        });

        // Firefox fix - not closing the new tab
        if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
          emailWindow.close();
        }
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxUpdateNote(notes_id, text) {
  return function (dispatch) {
    return jQuery.post("/feedback/note/" + notes_id + "/ajax/update", { data: { text: text, notes_id: notes_id, instance_uuid: window.instance_uuid ?? null } }).then(
      (success) => {
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        // dispatch(resetCurrentForwards({}));
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxCreateNote(text, user_id, feedback_id, user_name, state, callback = null) {
  if (jQuery('.sender_id').length > 0) {
    var sender_id = jQuery('.sender_id').val();
  }
  if (!window.instance_uuid) {
    window.instance_uuid = uuid.v4();
  }
  return function (dispatch) {
    return jQuery.post("/feedback/note/ajax/create", { data: { text: text, user_id: user_id, feedback_id: feedback_id ?? state.checked_feedbacks, instance_uuid: window.instance_uuid ?? null, userinfo: user_name ?? null, forwarded_by: window.forwarded_by ?? null, recipient: window.recipient ?? null } }).then(
      (success) => {
        if (feedback_id) {
          if (state.selected_feedback) {
            dispatch(setFeedbackFromBody({...state.feedback_detail, ...JSON.parse(success)}));
            dispatch(setFeedbackDetailPagination());
          }
          dispatch(setFeedbackAlert(JSON.parse(success)));
          showAlert();
        }

        if (callback) {
          callback();
        }
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxDeleteNote(notes_id, feedback_id) {
  return function (dispatch) {
    return jQuery.post("/feedback/" + feedback_id + "/note/" + notes_id + "/ajax/delete", { data: { security: true, notes_id: notes_id, feedback_id: feedback_id } }).then(
      (success) => {
        dispatch(setFeedbackFromBody(JSON.parse(success)));
        dispatch(setFeedbackAlert(JSON.parse(success)));
        showAlert();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxNewChat(body_text, feedback_id) {
  return function (dispatch) {
    dispatch(setLoading({ loading: true, location: 'chat' }));
    return jQuery.post("/feedback/" + feedback_id + "/chat/ajax/create", { body: body_text }).then(
      (success) => {

        chatDown();
      },
      (error) => console.log(error),
    );
  };
}

export function ajaxTyping(feedback_id, typing) {
  return function (dispatch) {
    return jQuery.post("/feedback/" + feedback_id + "/chat/ajax/typing", {
      typing: typing,
      instance_uuid: window.instance_uuid
    }).then(
      (success) => {
        chatDown();
      },
      (error) => console.log(error),
    );
  };
}

export const ajaxNewChatVC = (message, feedback_id) => async (dispatch) => {
    try {
        dispatch(setLoading({ loading: true, location: 'chat' }));

        const formData = new FormData();

        if (message) {
            formData.append('message', message);
        }

        const chatAttachments = window.chatAttachments;
        if (chatAttachments?.length) {
            chatAttachments.forEach(attachment => formData.append('attachments[]', attachment.obj));
        }
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

        const response = await fetch(`/feedback/${feedback_id}/chat`, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Socket-ID': window.socketId,
                'X-CSRF-TOKEN': csrfToken || '',
                'Accept': 'application/json',
            },
        });

        const jsonResponse = await response.json();

        dispatch(setLoading({ loading: false, location: 'chat' }));

        if (response.status === 201) {
            message = message.replace(/<br \/>/gi, "");
            dispatch(handleMessageResponse(jsonResponse.data));
            dispatch(getChatResponseTime(feedback_id));
            chatDown();
            if (data.chat.user.user_id !== window.current_user) {
                dispatch(notifyMe(__("New Chat Message"), message, feedback_id, 'new_chat', data.id));
                jQuery.playSound("/sounds/tone2.mp3");
            }
        } else {
            dispatch(setFeedbackAlert({
                alert: {
                    alert_class: "danger",
                    alert_message: __('Failed to send message'),
                    alert: true,
                    alert_location: "chat"
                }
            }));
            showAlert();
            return;
        }

        chatDown();

    } catch (error) {
        dispatch(setLoading({ loading: false, location: 'chat' }));
    }
};

export function setTimerInterval() {
  return function (dispatch) {
    window.time = setInterval(() => {
      dispatch(decrementTimer());
    }, 1000);
  };
}

export function setOnlineInterval() {
  return function (dispatch) {
    window.online_interval = setInterval(() => {
      dispatch(updateOnlineUsers());
    }, 1000);
  };
}

export function setSearchTimerInterval() {
  return function (dispatch) {
    window.time = setInterval(() => {
      dispatch(decrementSearchTimer());
    }, 500);
  };
}

export function clearTimerInterval() {
  return function (dispatch) {
    clearInterval(window.time);
  };
}

export function ajaxUploadFile(feedback_id, file) {
  return function (dispatch) {
    var file_data = file;
    var form_data = new FormData();
    form_data.append('file', file_data);
    var alert = { alert: { alert_class: "warning", alert_message: __("Please wait while we upload your file(s)"), alert: true, alert_location: "dropzone" } };
    dispatch(setFeedbackAlert(alert));
    showAlertAlt();
    return jQuery.ajax({
      type: "POST",
      url: "/feedback/" + feedback_id + "/attachment/upload",
      body: form_data,
      cache: false,
      contentType: false,
      processData: false,
      dataType: 'JSON',
      data: form_data,
    }).then(
      (success) => {
        dispatch(updateAttachments(success));
        var alert = { alert: { alert_class: "success", alert_message: __("Successfully uploaded your file(s)"), alert: true, alert_location: "dropzone" } };
        dispatch(setFeedbackAlert(alert));
        showAlertAlt();
        setTimeout(function () {
          hideAlertAlt();
        }, 1000);
      },
      (error) => {
        console.log("error");
        hideAlertAlt();
      }
    );
  };
}

export function ajaxRemoveFile(feedback_id, file_id) {
  return function (dispatch) {
    var alert = { alert: { alert_class: "warning", alert_message: __("Please wait while we remove the attachment."), alert: true, alert_location: "admin-attachments" } };
    dispatch(setFeedbackAlert(alert));
    showAlertAlt();
    return jQuery.ajax({
      type: "POST",
      url: "/feedback/" + feedback_id + "/attachment/" + file_id + "/remove",
      data: { file_id: file_id },
    }).then(
      (success) => {
        dispatch(updateAttachments(JSON.parse(success)));
        var alert = { alert: { alert_class: "success", alert_message: __("Successfully removed the attachment."), alert: true, alert_location: "admin-attachments" } };
        dispatch(setFeedbackAlert(alert));
        showAlertAlt();
        setTimeout(function () {
          hideAlertAlt();
        }, 1000);
      },
      (error) => {
        hideAlertAlt();
      }
    );
  };
}

export function ajaxNewReminder(datetime, email, text, feedback_id, state) {
  return function (dispatch) {
    return jQuery.post(`/feedback/${feedback_id}/reminder/ajax/create`, { data: { datetime: datetime, email: email, text: text, feedback_id: feedback_id }}).then(
      (success) => {

        var alert = { alert: { alert_class: "success", alert_message: __("Your Reminder Has Been Set!"), alert: true, alert_location: "pendingreminder" } };
        setTimeout(() => {
          dispatch(setFeedbackAlert(alert));
          jQuery('body').find('.alert').show()
        }, 2000);
        setTimeout(() => {
          jQuery('.modal').modal('hide');
          dispatch(ajaxUpdateFeedbackStatus(feedback_id, window.feedbackStatus.Pending.value, state));
        }, 5000);
      },
      (error) => console.log(error),
    );
  };
}

//Misc Functions:
export function getRequestedVia(feedback) {
  var requested = [];
  var response_via_text = __("Response requested via:");
  var formatted = "";
  if (feedback.is_text) {
    requested.push("Chat");
  }
  if (feedback.is_whatsapp) {
    requested.push("Chat (Whatsapp)");
  }
  if (feedback.is_phone) {
    requested.push("Phone Call");
  }
  if (feedback.is_phone_call) {
    requested.push("Phone Call");
  }
  if (feedback.is_email) {
    requested.push("Email");
  }
  requested = requested.join(', ');
  if (requested.length < 1) {
    response_via_text = __("Response Not Requested");
    formatted = response_via_text;
  } else {
    formatted = response_via_text + " " + requested;
  }
  return formatted;
}

export function getRequestedViaV2(feedback) {
  let arr = [];
  let conjunction = __("and");
  let ifempty = __("Response Not Requested");


  let firstName = feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "";
  let lastName = feedback.is_include_contact && feedback.user.lastname ? feedback.user.lastname : "";
  let usernameString = firstName + " " + lastName;
  let isAnonymous = !feedback.is_include_contact || usernameString.trim().length === 0;

  if (isAnonymous) {
    return ifempty;
  }
  if (feedback.is_text) {
    arr.push(__("Chat"));
  }
  if (feedback.is_whatsapp) {
    arr.push(__("Chat (Whatsapp)"));
  }
  if (feedback.is_phone) {
    arr.push(__("Phone Call"));
  }
  if (feedback.is_phone_call) {
    arr.push(__("Phone Call"));
  }
  if (feedback.is_email) {
    arr.push(__("Email"));
  }
  let l = arr.length;
  if (!l) return ifempty;
  if (l < 2) return arr[0] + __(" response requested");
  if (l < 3) return arr.join(` ${conjunction} `) + __(" responses requested");;
  arr = arr.slice();
  arr[l - 1] = `${conjunction} ${arr[l - 1]}`;
  return arr.join(", ") + __(" responses requested");
}

export function getChatStatus(feedback) {
  var chat_button_text = __("Go to Chat");
  var chat_alert = false;
  if (feedback.chat_status == 'Chat Not Started' && feedback.is_text == 1) {
    chat_button_text = __("Start Chat");
    chat_alert = true;
  }
  return { chat_alert: chat_alert, chat_button_text: chat_button_text };
}

export function convertTimeframeTitle(timeframe) {
  if (timeframe === "monthToDate") {
    return __("Month to Date");
  }
  if (timeframe === "weekToDate") {
    return __("Week to Date");
  }
  if (timeframe === "today") {
    return __("Today");
  }
  if (timeframe === "yesterday") {
    return __("Yesterday");
  }
  if (timeframe === "lifetime") {
    return __("Lifetime");
  }
  if (timeframe === "last30") {
    return __("Last 30 Days");
  }
  if (timeframe === "custom") {
    return __("Custom Timeframe");
  }
}

export function getStarsJSX(rating, starType = "OTF", hidelogo = false) {
  let img;
  if (rating) {
    let stars = [];
    if (rating > 0) {
      for (let i = 0; i < parseInt(rating); i++) {
        stars.push(<i className="fas fa-star text-warning rating-star" key={i}></i>);
      }
    }
    const diff = 5 - parseInt(rating);
    if (diff > 0) {
      for (let i = 0; i < diff; i++) {
        stars.push(<i className="far fa-star text-warning rating-star" key={"empty_" + i}></i>);
      }
    }

    if (!hidelogo) {
      if (starType === "ratethisbiz") {
        img =
          <img key="rtb" src="/img/rate-this-biz-logo.png" className="feedback-list-star-logo" alt="stars" />;
      } else if (starType === "OTF" || starType === "RO") {
        img = <img key="otf" src="/img/onethrufive-sm.png" className="feedback-list-star-logo d-inline mr-1"
          alt="stars" />;
      } else if (starType === "google") {
        img = <i className="fab fa-google text-primary d-inline-block mr-1"></i>;
      }
      stars.unshift(img);
    }
    return stars;
  }

  return null;
}

export function reviewLinkSent(chats) {
    let includes = false;
    chats.forEach(function (chat) {
        if (chat.message?.includes('ratethisbiz.com') || chat.message?.includes('1thru5.com')) {
            includes = true;
        }
    });

    return includes;
}

export function getHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    var parts = match[2].split("\.");

    return parts[parts.length - 2] + "." + parts[parts.length - 1];
  } else {
    return null;
  }
}

export function warnNoChat(is_include_contact, dispatcher) {

  var modal_id = "warnNoChat";
  var modal_title = __("Chat Unavailable");
  var modal_body = __("Chat feature is disabled because this Feedback was sent anonymously and does not have a phone number associated with it.");
  if (is_include_contact) {
    modal_body = __("Chat feature is disabled because this Feedback does not have a phone number associated with it.");
  }

  var button_1_class = "hidden hidden";
  var button_1_id = "hidden";
  var button_1_text = __("Ok");
  var button_2_class = "primary";
  var button_2_id = "cancel";
  var button_2_text = __("Ok");

  dispatcher(updateModalContent({
    modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text,
    button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text
  }));

  jQuery('.modal:not(.error)').modal();
}

export function noAiResponseWarning(dispatcher) {
    var modal_id = "noAiResponseWarning";
    var modal_title = __("AI response unavailable");
    var modal_body = __("AI Recommended Response currently unavailable. Please try again later.");

    var button_1_class = "hidden hidden";
    var button_1_id = "hidden";
    var button_1_text = __("Ok");
    var button_2_class = "primary";
    var button_2_id = "cancel";
    var button_2_text = __("Ok");

    dispatcher(updateModalContent({
        modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text,
        button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text
    }));

    jQuery('.modal:not(.error)').modal();
}

export function aiRequestNotAllowed(dispatcher) {

    var modal_id = "aiRequestNotAllowed";
    var modal_title = __("AI response unavailable");
    var modal_body = __("AI Recommended Response currently only available for initial response to customer");

    var button_1_class = "hidden hidden";
    var button_1_id = "hidden";
    var button_1_text = __("Ok");
    var button_2_class = "primary";
    var button_2_id = "cancel";
    var button_2_text = __("Ok");

    dispatcher(updateModalContent({
        modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text,
        button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text
    }));

    jQuery('.modal:not(.error)').modal();
}

export function warnUserDidntRequestedChat(dispatcher) {
  var modal_id = "warnUserDidntRequestedChat";
  var modal_title = __("User hasn't requested a Chat");
  var modal_body = __("Are you sure you want to continue ?");
  var button_1_class = "primary";
  var button_1_id = "chatAnyway";
  var button_1_text = __("Chat anyway");
  var button_2_class = "chatAnyway";
  var button_2_id = "cancel";
  var button_2_text = __("Cancel");

  dispatcher(updateModalContent({
    modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text,
    button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text
  }));

  jQuery('.modal:not(.error)').modal();
}

export function containsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (Object.values(list[i])[0] == Object.values(obj)[0]) {
      return true;
    }
  }

  return false;
}

export function getAttachmentsUrls(feedback) {
  var fa = feedback.feedback_attachments;
  var attachments = [];
  for (let i = 0; i < fa.length; i++) {
    if (fa[i].type === 'feedback_attachment') {
      continue;
    }


    if (fa[i].mime_type.toLowerCase().includes('image') || fa[i].mime_type.toLowerCase().includes('video')) {
      if (fa[i].file.toLowerCase().includes('.mov') || fa[i].file.toLowerCase().includes('.mp4') || fa[i].file.toLowerCase().includes('.m4v') || fa[i].file.toLowerCase().includes('.qt')) {
        var html = <video key={'video-' + fa[i]} className="video-attachment" controls>
          <source key={'key-' + i} src={fa[i].full_url} type="video/mp4" />
        </video>
      } else {
        var html = <img key={'img-' + i} id={i} src={fa[i].full_thumb_url} alt="Attachment Image"
          className="img-attachment cursor-pointer" data-full-image-url={fa[i].full_url} />;
      }

      attachments.push(<div key={'unit-' + i} className="col-md-4 mt-3">{html}</div>);
    } else if (fa[i].mime_type.toLowerCase().includes('application/pdf')) {
      var html = <img key={'img-' + i} id={i} src="/img/pdf.png" alt="Attachment Image" className="img-attachment cursor-pointer pdf-attachment" data-full-image-url={fa[i].full_url} />;
      attachments.push(<div key={'unit-' + i} className="col-md-4 mt-3">{html}</div>);
    }
  }

  return attachments.length > 0 ? attachments : null;
}

export function getAttachmentsUrlsFBList(feedback, handlefunc) {
  if (feedback.feedback_attachments && feedback.feedback_attachments.length > 0) {
    var attachments = [];
    for (var a in feedback.feedback_attachments) {
      var att = feedback.feedback_attachments[a];
      if (att.type === 'feedback_attachment') {
        continue;
      }
      if (att.file.toLowerCase().includes('.mov') || att.file.toLowerCase().includes('.mp4') || att.file.toLowerCase().includes('.m4v') || att.file.toLowerCase().includes('.qt')) {
        var html = <img key={'img-' + att.id} id={a} src="/images/play-button-for-video-thumbnail.png"
          alt="Attachment Video" onClick={handlefunc}
          className="video-attachment cursor-pointer w-100 rounded border bg-primary" />;
      } else {
        if (att.file.toLowerCase().includes('pdf')) {
          var html = <img key={'img-' + att.id} id={a} src="/img/pdf.png" data-full-image-url={att.full_url}
            alt="Attachment Image" className="img-attachment cursor-pointer w-100 rounded border pdf-attachment-small" />;
        } else {
          var html = <img key={'img-' + att.id} id={a} src={att.full_thumb_url} data-full-image-url={att.full_url}
            alt="Attachment Image" className="img-attachment cursor-pointer w-100 rounded border" />;
        }
      }
      attachments.push(<div key={'unit-' + a} className="col-2 pr-2 pl-0">{html}</div>);
    }
    return attachments;
  }

  return null;
}

export function genEmailButton(feedback, classes) {
  var url = (window.manage_server ? window.manage_server : "https://manage.realtimefeedback.com") + "/feedback/" + feedback.feedback_id + "/detail/";
  var mailto_subject = __("Feedback submitted by ") + (feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "Anonymous") + (feedback.is_include_contact && feedback.user.lastname ? " " + feedback.user.lastname + " " : " ") + "to " + feedback.business.name + " on " + feedback.created_at;
  var mailto_body = `Here are the details for the Feedback submitted by ` + (feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "Anonymous") + (feedback.is_include_contact && feedback.user.lastname ? " " + feedback.user.lastname + " " : " ") + `to ` + feedback.business.name + ` on ` + feedback.created_at + `
					%0D%0A
					%0D%0A
					Feedback Sent:
					%0D%0A
					`+ feedback.description + `
					%0D%0A
					%0D%0A
					Full Feedback details can be viewed here:
					%0D%0A
					`+ url;
  var email_forward = <a className={"sendemail " + classes} href={"mailto:?subject=" + mailto_subject + "&body=" + mailto_body} target="_blank"><i className="far fa-envelope mr-1"></i>&nbsp;Via Email</a>;
  return email_forward
}

export function showAlert(delayTime = 4000, callback = undefined) {
  jQuery('body').find('.alert')
    .show()
    .removeClass('anim-scale-in-y')
    .removeClass('anim-scale-out-y')
    .addClass('anim-scale-in-y');
  setTimeout(function () {
    jQuery('body').find('.alert')
      .removeClass("anim-scale-in-y")
      .addClass("anim-scale-out-y")
      .on("animationend", function () {
        jQuery('body').find('.alert').hide();
        if (callback) {
          callback();
        }
      });
  }, delayTime);
}

export function showAlertAlt() {
  jQuery('body').find('.alert')
    .show()
    .removeClass('anim-scale-in-y')
    .removeClass('anim-scale-out-y')
    .addClass('anim-scale-in-y');
}

export function hideAlertAlt() {
  jQuery('body').find('.alert').removeClass("anim-scale-in-y").addClass("anim-scale-out-y").on("animationend", function () {
    jQuery('body').find('.alert').hide();
  });
}

export function formatPhone(phone) {
  return new AsYouType('US').input(phone);
}

export function cleanPhone(phone) {
  var p = parsePhoneNumberFromString(phone, "US");
  return p.format("E.164");
}

export function findWithAttr(array, attr, value) {
    for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return false;
}

export function findWithAttrObj(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i].attr === value) {
      return i;
    }
  }
  return false;
}

export function checkPropertyValueByObjectIds(haystack = [], needle = [], property = '', value) {
  let exists = false;
  for (let i = 0; i < haystack.length; i += 1) {
    if (needle.includes(haystack[i].id) && haystack[i][property] === value) {
      exists = true;
      break;
    }
  }
  return exists;
}

export function formatPhoneNatOrIntl(ophone) {
  var phone = parsePhoneNumberFromString(ophone);
  if (phone) {
    if (phone.countryCallingCode == "1") {
      return phone.formatNational();
    }
    else {
      return phone.formatInternational();
    }
  }

  return ophone;
}

export function getChatResponseTime(feedback_id) {
  return function (dispatch) {
    return jQuery.ajax("/feedback/" + feedback_id + "/ajax/get-response-time").then(
      (success) => {
        dispatch(setPriority(JSON.parse(success)));
        dispatch(updateFeedbackResponseTime(success));
      },
      (error) => console.log(error),
    );
  };
}

export function clearChatAttachments() {
  window.chatAttachments = [];

  jQuery('.close-icon').each(function () {
    jQuery("#" + jQuery(this).attr('data-feedback-attachment-item')).remove();
    jQuery(this).closest(".feedback-attachment-preview-item").remove();
  });
}

//websocket connection
export function connectWebsocket() {
  return function (dispatch) {
    const socket = io();
    socket.on('connect', function () {
        window.socketId = socket.id;
      for (const i in window.encoded_ids) {
        socket.emit("subscribe", encoded_ids[i]);
      }
    });

    socket.on("fbevent", function (data) {
        console.log('socket data', data);
      let dept_id;
      if (data.type === "chat_message") {
        data.chat.Body = data.chat.Body.replace(/<br \/>/gi, "");
        dispatch(handleMessageResponse(data));
        dispatch(getChatResponseTime(data.feedback_id));
        chatDown();
        if (data.chat.user.user_id !== window.current_user) {
          dispatch(notifyMe("New Chat Message", data.chat.Body, data.feedback_id, data.type, data.chat.id));
          jQuery.playSound("/sounds/tone2.mp3");
        }
      }

      if (data.event === 'incomingChatMessage') {
          const payload = data.payload;
          payload.message?.replace(/<br \/>/gi, "");
          dispatch(handleMessageResponse(payload));
          dispatch(getChatResponseTime(payload.feedback_id));
          chatDown();
          if (payload.sender.userId !== window.current_user) {
              dispatch(notifyMe("New Chat Message", payload.message, payload.feedback_id, 'chat_message', payload.id));
              jQuery.playSound("/sounds/tone2.mp3");
          }
      }

        if (data.event === "outgoingChatMessage" && data.payload.socket !== socket.id) {
            const payload = data.payload;
            payload.message?.replace(/<br \/>/gi, "");
            dispatch(handleMessageResponse(payload));
            dispatch(getChatResponseTime(payload.feedback_id));
            chatDown();
        }

      if (data.type === "chat_message_attachment") {
        dispatch(handleMessageAttachment(data))
      }

      if (data.type === "user_typing") {
        dispatch(handleUserTyping(data));
      }

      if (data.type === "new_rating") {
        if (!window.backend_department_ids) {
          var stars = "";
          if (data.feedback.rating.rating) {
            for (var i = 0; i < data.feedback.rating.rating; i++) {
              stars += "★";
            }
          }
          dispatch(handleRatingResponse(data));
        } else {
          dept_id = data.feedback.department_id;
          if (window.backend_department_ids.includes(parseInt(data.feedback.department_id))) {
            var stars = "";
            if (data.feedback.rating.rating) {
              for (var i = 0; i < data.feedback.rating.rating; i++) {
                stars += "★";
              }
            }
            dispatch(handleRatingResponse(data));
          }
        }
      }

      if (data.type === "new_feedback") {
        if (!window.backend_department_ids) {
          dispatch(notifyMe(__("New Feedback Submitted") + (data.feedback.custom_qr_code ? " From: " + data.feedback.custom_qr_code : ""), data.feedback.description, data.feedback_id, data.type, data.feedback_id));
          jQuery.playSound("/sounds/tone2.mp3");
        } else {
          dept_id = data.feedback.department_id;
          if (window.backend_department_ids.includes(parseInt(dept_id))) {
            dispatch(notifyMe(__("New Feedback Submitted") + (data.feedback.custom_qr_code ? " From: " + data.feedback.custom_qr_code : ""), data.feedback.description, data.feedback_id, data.type, data.feedback_id));
            jQuery.playSound("/sounds/tone2.mp3");
          }
        }
      }

      if (data.type === "new_note") {
        if (data.instance_uuid !== window.instance_uuid) {
          dispatch(notifyMe(__("New Note Added to a Feedback"), data.note.note, data.feedback_id, data.type, data.feedback_id));
          dispatch(handleNoteResponse(data));
        }
      }

      if (data.event === "feedback_status_updated") {
          if (data.payload?.instance_uuid !== window?.instance_uuid) {
              // update feedback list when feedback status is updated
              dispatch(ajaxPrependFeedbackList(data.payload.feedbackId));
          }
      }

        if (data.event === "feedback_prompt_updated") {
            dispatch(handleFeedbackPromptUpdate(data));
        }

      if (data.type === "new_status_history") {
        if (data.instance_uuid !== window.instance_uuid) {
          dispatch(handleStatusHistoryResponse(data));
        }
      }

      if (data.type === "update_note") {
        if (data.instance_uuid !== window.instance_uuid) {
          dispatch(handleNoteUpdateResponse(data));
        }
      }

      if (data.type === "update_status_history") {
        if (data.instance_uuid !== window.instance_uuid) {
          dispatch(handleStatusHistoryUpdateResponse(data));
        }
      }

      if (data.type === "feedback_read") {
        dispatch(handleFeedbackRead(data));
      }

      if (data.type === "user_activity") {
        dispatch(handleUserActivityUpdateResponse(data));
      }

      if (data.type === 'assigned_employee') {
        if (data.instance_uuid !== window.instance_uuid) {
          dispatch(setAssignEmployee(data));
        }
      }

      if (data.event === 'open_feedbacks') {
        console.log('open_feedbacks', data);
      }

        if (data.event === 'feedback_geolocation_update') {
            dispatch(handleFeedbackGeolocationUpdated(data));
        }

    });
  };
}

//notification permission
export function handleNotificationPermission(permission) {
  return function (dispatch) {
    Notification.requestPermission().then(function (permission) {
      // If the user accepts, let's create a notification
      dispatch(setNotificationPermission(permission === "granted"));
    });
  };
}

export function getChatIcons(feedback, spanClasses = '') {
    let showIcons = (feedback.is_text || feedback.is_whatsapp || feedback.is_email || feedback.is_phone_call || feedback.is_phone);

    let firstName = feedback.is_include_contact && feedback.user.firstname ? feedback.user.firstname : "";
    let lastName = feedback.is_include_contact && feedback.user.lastname ? feedback.user.lastname : "";
    let usernameString = firstName + " " + lastName;
    let isAnonymous = !feedback.is_include_contact || usernameString.trim().length === 0;

    if (isAnonymous) {
    return <span className={"d-flex feedback-card-v2-icons " + spanClasses + (feedback.priority === 30 ? " anim-pulse-icon" : "")}></span>;
    }

    let showTextIcon = feedback.is_text || feedback.is_whatsapp;

    let showTextIconRed = showTextIcon
        && (feedback.chat_status === 'Chat Not Started' || feedback.getLastChatIfFeedbacker)
        && feedback.status !== window.feedbackStatus.Resolved.value;

    showTextIconRed = feedback.chats && feedback.chats.length === 1 && feedback.chats[0].is_auto_response
        ? showTextIcon
        : showTextIconRed;

    let showPhoneIcon = feedback.is_phone_call || feedback.is_phone;
    let showEmailIcon = feedback.is_email;

    let iconList = <span className={"d-flex feedback-card-v2-icons " + spanClasses + (feedback.priority === 30 ? " anim-pulse-icon" : "")}>

    {showIcons && showTextIcon ? (showTextIconRed ? <img src="/img/status-icon-danger-v2.svg" data-toggle="tooltip" data-placement="bottom"
      data-title={feedback.getLastChatIfFeedbacker ? __('Customer requested a chat response and has been responded to. But latest message was from customer, which might need a reply.') : __('Customer requested a chat response, and has not yet been responded to')} /> : <img src="/img/status-icon-chat-v2.svg" data-toggle="tooltip" data-placement="bottom"
        data-title={__('Customer requested a chat response, but no response needed at this time')} />) : null}

    {showIcons && showPhoneIcon ? <img src="/img/status-icon-call-v2.svg" data-toggle="tooltip" data-placement="bottom"
      data-title={__('Customer requested a phone response')} /> : null}

    {showIcons && showEmailIcon ? <img src="/img/status-icon-email-v2.svg" data-toggle="tooltip" data-placement="bottom"
      data-title={__('Customer requested an email response')} /> : null}

    {!showIcons && "-"}

    </span>;
    return iconList;
}

export function getSmiley(feedback) {
  let smiley = <i></i>;
  let classes = "";
  let color = {};
  let datasmiley = "";
  let smileyScore = feedback.smiley_score;
  if (smileyScore === 100) {
    classes = "far fa-laugh fa-2x fa-stack-1x";
    color = '#01ff02';
    datasmiley = "100";
  } else if (smileyScore === 75) {
    classes = "far fa-smile fa-2x fa-stack-1x";
    color = '#abef0e';
    datasmiley = "75";
  } else if (smileyScore === 50) {
    classes = "far fa-meh fa-2x fa-stack-1x";
    color = '#b5b5b5';
    datasmiley = "50";
  } else if (smileyScore === 25) {
    classes = "far fa-frown fa-2x fa-stack-1x";
    color = '#ffcf08';
    datasmiley = "25";
  } else if (smileyScore === 0) {
    classes = "far fa-angry fa-2x fa-stack-1x";
    color = '#fe0100';
    datasmiley = "0";
  }

  if (smileyScore >= 0 && smileyScore != null) {
    smiley = <span className="fa-stack" style={{ fontSize: "0.52em" }}><i className="fas fa-circle  fa-stack-2x" style={{ color: color }}></i><i className={classes} style={{ color: "#000000" }} data-smiley={datasmiley}></i></span>
  }
  if ((smileyScore === -1 || smileyScore == null)) {
    smiley = null;
  }

  return smiley;
}

export function getPhone(feedback) {
  const phoneNumber = feedback.user.phone;

  if (!phoneNumber || phoneNumber.length <= 9) {
      return <span className="text-gray">None</span>;
  }

  return (
      <a href={"tel:" + phoneNumber} className="text-primary">
          {parsePhoneNumberFromString(phoneNumber).format("NATIONAL")}
      </a>
  );
}

export function getEmail(feedback) {
  return <span className=""><a href={feedback.user.email ? "mailto:" + feedback.user.email : null} target="_blank">{feedback.user.email ? feedback.user.email : "None"}</a></span>
}

export function getFeedbackLength(feedback) {
  return <a data-toggle="tooltip" data-title='Lifetime amount of Feedbacks from this Feedbacker'
    href={"/business/" + feedback.business.business_id + "/feedbacker/" + feedback.user.user_id}>
      {feedback.user.feedbacks.filter(f => (f.business_id === feedback.business.business_id && f.is_include_contact === 1)).length}
  </a>
}

export function validateFeedbackSorting(sorting) {
    const sortingArray = [
        'sort-created_at-desc',
        'sort-created_at-asc',
        'sort-priority-desc',
        'sort-priority-asc',
        'sort-smiley_score-desc',
        'sort-smiley_score-asc',
        'sort-sentiment_score-desc',
        'sort-sentiment_score-asc',
    ];

    return sortingArray.includes(sorting) ? sorting : 'sort-created_at-desc';
}

export function checkIfNotificationsInWindow() {
  if (!("Notification" in window)) {
    alert(__("This browser does not support desktop notifications"));
    return false;
  }
  return true;
}

export function notifyMe(msg_text, msg_message, feedback_id, type, item_id = null) {
  return function (dispatch) {
    let notification;
      checkIfNotificationsInWindow();
    if ("Notification" in window && Notification.permission === "granted") {
      if (type === "chat_message" || type === "new_rating") {
          notification = handleMessageNotification(dispatch, type);
      }
      if (type === "new_feedback") {
          notification = handleFeedbackNotification(notification, dispatch);
      }

      if (type === 'new_note') {
        handleNoteNotification(notification, dispatch);
      }
    } else if ("Notification" in window && Notification.permission !== "denied") {
      Notification.requestPermission().then(function (permission) {
        if (permission === "granted") {
          if (type === "chat_message" || type === "new_rating") {
            let notification = handleMessageNotification(dispatch, type);
          }
          if (type === "new_feedback") {
            let notification = handleFeedbackNotification(notification, dispatch);
          }
          if (type === 'new_note') {
            handleNoteNotification(notification, dispatch);
          }
        } else {
        }
      });
    } else {
      dispatch(ajaxPrependFeedbackList(feedback_id));
    }
  };

  function handleNoteNotification(notification, dispatch) {
    var notification = generateFeedbackNotification(notification);
    if (notification) {
      addNotificationEventListeners(notification, dispatch);
    }
    return notification;
  }
  function handleFeedbackNotification(notification, dispatch) {
    var notification = generateFeedbackNotification(notification);
    dispatch(ajaxPrependFeedbackList(feedback_id));
    if (notification) {
      addNotificationEventListeners(notification, dispatch);
    }
    return notification;
  }

  function generateFeedbackNotification(notification) {
    var notification = false;
    if (readCookie("latest_browser_window") && readCookie("latest_browser_window") === window.instance_uuid) {
      notification = new Notification(msg_text, { body: msg_message.substring(0, 40) + "...", renotify: true, tag: "newFeedback" + item_id });
    }
    return notification;
  }

  function addNotificationEventListeners(notification, dispatch) {
    if (jQuery('.chat-detail').length > 0) {
      notification.addEventListener("click", function (event) {
        parent.focus();
        window.focus();
        dispatch(setLoading({ loading: true, location: 'page' }));
        window.location = "/feedback/" + feedback_id + "/selected";
      });
    } else {
      notification.addEventListener("click", function (event) {
        parent.focus();
        window.focus();
        if (!jQuery('.feedback-detail').length > 0) {
          window.location = "/feedback/" + feedback_id + "/selected";
        }
        dispatch(setLoading({ loading: true, location: 'page' }));
        dispatch(ajaxFeedbackListSingle(feedback_id));
      });
    }
  }

  function doTheMessageNotification(notification, msg_text, msg_message, item_id, dispatch, feedback_id, tag_type) {
    notification = new Notification(msg_text, { body: msg_message && msg_message.length > 0 ? msg_message.substring(0, 40) + "..." : '', renotify: true, tag: tag_type + item_id });
    notification.addEventListener("click", function (event) {
      parent.focus();
      window.focus();
      dispatch(setLoading({ loading: true, location: 'page' }));
      dispatch(ajaxFeedbackListSingle(feedback_id));
    });
    return notification;
  }

  function handleMessageNotification(dispatch, tag_type) {
    let notification = false;
    if (readCookie("latest_browser_window")) {
      if (readCookie("latest_browser_window") === window.instance_uuid) {
        notification = doTheMessageNotification(notification, msg_text, msg_message, item_id, dispatch, feedback_id, tag_type);
      }
    } else {
      notification = doTheMessageNotification(notification, msg_text, msg_message, item_id, dispatch, feedback_id, tag_type);
    }
    return notification;
  }

}

export function setRatingsFilter(ratingsArray = []) {
    window.localStorage.setItem('ratingsFilter', JSON.stringify(ratingsArray));
}

export function getRatingsFilter() {
  return JSON.parse(window.localStorage.getItem('ratingsFilter'));
}

export function deleteRatingsFilter() {
    window.localStorage.removeItem('ratingsFilter');
}

export function setDepartmentFilter (departmentsArray = []) {
  window.localStorage.setItem('departmentFilter', JSON.stringify(departmentsArray))
}

export function getDepartmentFilter() {
  return JSON.parse(window.localStorage.getItem('departmentFilter'));
}

export function deleteDepartmentFilter() {
    window.localStorage.removeItem('departmentFilter');
}

export function setTagFilter (tagsArray = []) {
  window.localStorage.setItem('tagFilter', JSON.stringify(tagsArray))
}

export function getTagFilter() {
  return JSON.parse(window.localStorage.getItem('tagFilter'));
}

export function getOriginFilter() {
  return JSON.parse(window.localStorage.getItem('originFilter'));
}

export function deleteOriginFilter() {
    window.localStorage.removeItem('originFilter');
}

export function setOriginFilter (active) {
    window.localStorage.setItem('originFilter', JSON.stringify(active))
}

export function deleteTagFilter() {
    window.localStorage.removeItem('tagFilter');
}

export function setQrCodeFilter () {
  window.localStorage.setItem('qrCodeFilter', '1')
}

export function getQrCodeFilter() {
  return JSON.parse(window.localStorage.getItem('qrCodeFilter'));
}

export function deleteQrCodeFilter() {
    window.localStorage.removeItem('qrCodeFilter');
}

export function setWebToTextFilter () {
    window.localStorage.setItem('webToTextFilter', '1')
}

export function getWebToTextFilter() {
    return JSON.parse(window.localStorage.getItem('webToTextFilter'));
}

export function deleteWebToTextFilter() {
    window.localStorage.removeItem('webToTextFilter');
}

export function setNotWebToTextFilter () {
    window.localStorage.setItem('notWebToTextFilter', '1')
}

export function getNotWebToTextFilter() {
    return JSON.parse(window.localStorage.getItem('notWebToTextFilter'));
}

export function deleteNotWebToTextFilter() {
    window.localStorage.removeItem('notWebToTextFilter');
}

export function setLocation(locationString = '') {
    let location = {
        'previous': getLocation()?.current ?? '',
        'current': locationString
    };
    window.localStorage.setItem('location', JSON.stringify(location));
}

export function splitArrayInByNumbers(array, number) {
  return Array.from({ length: Math.ceil(array.length / number) }, (_, i) =>
      array.slice(i * number, i * number + number)
  )
}

export function getLocation() {
    return JSON.parse(window.localStorage.getItem('location'));
}

//End misc functions

//configure store and export state and actions
const store = configureStore({
  reducer: pageSlice.reducer
});
const { actions, reducer } = pageSlice;
export const {
    handleFeedbackPromptUpdate,
    setChatAnyway,
    setLoading,
    resetFeedbackPrompt,
    setCustomTimeframe,
    setOtherFilter,
    setQuery,
    setChatQuery,
    setNotificationPermission,
    prependFeedbackList,
    updateFeedbackResponseTime,
    updateSelectedFeedback,
    updateSelectedFeedbackNoRedirect,
    updateStatusInList,
    handleMessageResponse,
    handleMessageAttachment,
    handleStatusHistoryResponse,
    handleNoteResponse,
    handleStatusUpdate,
    handleFeedbackRead,
    handleStatusHistoryUpdateResponse,
    handleUserActivityUpdateResponse,
    handleNoteUpdateResponse,
    handleRatingResponse,
    handleFeedbackGeolocationUpdated,
    getState,
    handleUserTyping,
    IncrementSearchTyping,
    decrementTimer,
    decrementSearchTimer,
    setSelectedFeedback,
    deselectFeedback,
    setTotalPages,
    setLastestTime,
    setFeedbackDetail,
    updateModalContent,
    updateOnlineUsers,
    setFeedbackFromBody,
    setFeedbackAlert,
    setMaskedCall,
    clearMaskedCallProxy,
    setResponseSuggestion,
    errorResponseSuggestion,
    setAssignRatingPageEmployee,
    setAssignEmployee,
    updateAttachments,
    addForward,
    removeForward,
    resetAllForwards,
    resetCurrentForwards,
    resetCurrentEmailForwards,
    addEmailForward,
    removeEmailForward,
    toggleAddToContacts,
    addForwardContact,
    removeForwardContact,
    setSelectedNote,
    setNoteText,
    setFeedbackList,
    appendFeedbackList,
    updateTotals,
    updateOldestPending,
    setFilterStatus,
    setFilterTimeframe,
    setFeedbackCount,
    setPaginateCount,
    updateTable,
    setCurrentPage,
    setCurrentCursors,
    addEmailRecipient,
    addEmailKeywordRecipient,
    removeEmailRecipient,
    addPhoneRecipient,
    addSMSKeywordRecipient,
    removePhoneRecipient,
    addPrecanned,
    editPrecanned,
    deletePrecanned,
    addAutoresponseKeyword,
    editAutoresponseKeyword,
    deleteAutoresponseKeyword,
    addTags,
    editTags,
    deleteTags,
    errorTags,
    addForwards,
    editForwards,
    deleteForwards,
    updateCheckedFeedbacks,
    setSorting,
    setBusinessSorting,
    setPriority,
    setBusinessDepartmentCount,
    setFeedbackDetailPagination,
    setFeedbacksCount,
    setFeedbackStatus
} = actions;

//if elements is on the page
if (document.getElementById('Dashboard')) {
  ReactDOM.render(<Provider store={store}><Dashboard /></Provider>, document.getElementById('Dashboard'));
}
if (document.getElementById('AllDashboard')) {
    ReactDOM.render(<Provider store={store}><AllDashboard /></Provider>, document.getElementById('AllDashboard'));
}
if (document.getElementById('AdminDashboard')) {
    ReactDOM.render(<Provider store={store}><AdminDashboard /></Provider>, document.getElementById('AdminDashboard'));
}
if (document.getElementById('DashboardTables')) {
  ReactDOM.render(<Provider store={store}><DashboardTables /></Provider>, document.getElementById('DashboardTables'));
}
if (document.getElementById('DynamicTitle')) {
  ReactDOM.render(<Provider store={store}><DynamicTitle /></Provider>, document.getElementById('DynamicTitle'));
}
if (document.getElementById('DynamicTitleV2')) {
  ReactDOM.render(<Provider store={store}><DynamicTitleV2 /></Provider>, document.getElementById('DynamicTitleV2'));
}
if (document.getElementById('OnlineUsers')) {
  ReactDOM.render(<Provider store={store}><OnlineUsers /></Provider>, document.getElementById('OnlineUsers'));
}
if (document.getElementById('SelectedFeedback')) {
  ReactDOM.render(<Provider store={store}><SelectedFeedback /></Provider>, document.getElementById('SelectedFeedback'));
}
if (document.getElementById('FeedbackerDetail')) {
  ReactDOM.render(<Provider store={store}><FeedbackerDetail /></Provider>, document.getElementById('FeedbackerDetail'));
}
if (document.getElementById('Messenger')) {
  ReactDOM.render(<Provider store={store}><Messenger /></Provider>, document.getElementById('Messenger'));
}
if (document.getElementById('HistoryV2')) {
    ReactDOM.render(<Provider store={store}><History /></Provider>, document.getElementById('HistoryV2'));
}
if (document.getElementById('Archive')) {
  ReactDOM.render(<Provider store={store}><Archive /></Provider>, document.getElementById('Archive'));
}
if (document.getElementById('EditBusinessGroup')) {
  ReactDOM.render(<Provider store={store}><EditBusinessGroup /></Provider>, document.getElementById('EditBusinessGroup'));
}
if (document.getElementById('FeedbackSettingsForwards')) {
  ReactDOM.render(<Provider store={store}><FeedbackSettingsForwards /></Provider>, document.getElementById('FeedbackSettingsForwards'));
}
if (document.getElementById('FeedbackSettingsTags')) {
  ReactDOM.render(<Provider store={store}><FeedbackSettingsTagsV2 /></Provider>, document.getElementById('FeedbackSettingsTags'));
}
if (document.getElementById('Detail')) {
  ReactDOM.render(<Provider store={store}><Detail /></Provider>, document.getElementById('Detail'));
}
if (document.getElementById('Notifications')) {
  ReactDOM.render(<Provider store={store}><Notifications /></Provider>, document.getElementById('Notifications'));
}
if (document.getElementById('Timezone')) {
  ReactDOM.render(<Provider store={store}><Timezone /></Provider>, document.getElementById('Timezone'));
}
if (document.getElementById('ChatSettingsPrecanned')) {
  ReactDOM.render(<Provider store={store}><ChatSettingsPrecanned /></Provider>, document.getElementById('ChatSettingsPrecanned'));
}
if (document.getElementById('ChatSettingsAutoresponse')) {
  ReactDOM.render(<Provider store={store}><ChatSettingsAutoresponse /></Provider>, document.getElementById('ChatSettingsAutoresponse'));
}
if (document.getElementById('passwordInput')) {
  const label = document.getElementById('passwordInput').getAttribute('label');
  const confirmLabel = document.getElementById('passwordInput').getAttribute('confirmLabel');
  const layout = document.getElementById('passwordInput').getAttribute('layout');
  const required = document.getElementById('passwordInput').getAttribute('required') || '';
  const defaultShowRules =  document.getElementById('passwordInput').getAttribute('defaultShowRules') || '';
  ReactDOM.render(<PasswordInput label={label} confirmLabel={confirmLabel} layout={layout} required={required} defaultShowRules={defaultShowRules}></PasswordInput>, document.getElementById('passwordInput'));
}

if (document.getElementById('WebsocketConnector')) {
  ReactDOM.render(<Provider store={store}><WebsocketConnector /></Provider>, document.getElementById('WebsocketConnector'));
}

if (document.getElementById("CompanyProfile-EmailRecipients")) {
  ReactDOM.render(<Provider store={store}><EmailRecipients /></Provider>, document.getElementById('CompanyProfile-EmailRecipients'));
  ReactDOM.render(
    <Provider store={store}>
      <PhoneRecipients />
    </Provider>,
    document.getElementById("CompanyProfile-PhoneRecipients")
  );
}

if (document.getElementById("KeywordAlerts-EmailRecipients")) {
  ReactDOM.render(<Provider store={store}><KeywordEmailRecipients /></Provider>, document.getElementById('KeywordAlerts-EmailRecipients'));
  ReactDOM.render(
    <Provider store={store}>
      <KeywordPhoneRecipients />
      <Modal />
    </Provider>,
    document.getElementById("KeywordAlerts-PhoneRecipients")
  );
}

if (document.getElementById("ReviewTrackers")) {
  ReactDOM.render(<Provider store={store}><ReviewTrackers></ReviewTrackers></Provider>, document.getElementById('ReviewTrackers'))
}

if (document.getElementById("AISummary")) {
    ReactDOM.render(<Provider store={store}><AISummary></AISummary></Provider>, document.getElementById('AISummary'))
}

if (document.getElementById("ManageVins")) {
    ReactDOM.render(<Provider store={store}><ManageVins></ManageVins></Provider>, document.getElementById('ManageVins'))
}

if (document.getElementById("EditVin")) {
    ReactDOM.render(<Provider store={store}><EditVin></EditVin></Provider>, document.getElementById('EditVin'))
}

if (document.getElementById("AddVin")) {
    ReactDOM.render(<Provider store={store}><AddVin></AddVin></Provider>, document.getElementById('AddVin'))
}

if (document.getElementById("DGBSettings")) {
    ReactDOM.render(<Provider store={store}><DGBSettings></DGBSettings></Provider>, document.getElementById('DGBSettings'))
}

if (document.getElementById("demoCompaniesTable")) {
    ReactDOM.render(<Provider store={store}><DemoCompaniesTable></DemoCompaniesTable></Provider>, document.getElementById('demoCompaniesTable'))
}

window.formatPhone = formatPhone;

window.parsePhoneNumberFromString = parsePhoneNumberFromString;
